// Marketplace category pages — drawer filtres + bouton flottant + favoris
// (Le panier est géré dans site-header.js car visible sur toutes les pages)

// Avertissement affiché à l'expéditeur quand des coordonnées ont été masquées
// (modération auto côté serveur : emails, téléphones, liens, @réseaux).
var SDV_AVERTISSEMENT_COORDONNEES = SDV_T(
  "msg.contactMasked",
  "Pour votre sécurité et conformément aux règles du Salon du Vintage, le partage de coordonnées (email, téléphone, réseaux sociaux, liens) est interdit : ces informations ont été masquées dans votre message.",
);

function SDV_LOCALIZE_URL(url) {
  if (!url || typeof url !== "string") return url || "#";
  if (/^(?:https?:|mailto:|tel:|#)/i.test(url)) return url;
  const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/+$/, "/");
  if (root === "/" || url.indexOf(root) === 0) return url;
  return root + url.replace(/^\/+/, "");
}

// ─────────────────────────────────────────────────────────────
// Drawer filtres
// ─────────────────────────────────────────────────────────────
function fermerFilters() {
  const drawer = document.querySelector("[data-marketplace-drawer]");
  if (!drawer) return;
  drawer.classList.remove("is-open");
  document.body.style.overflow = "";
}

document.querySelectorAll("[data-drawer-open]").forEach((trigger) => {
  trigger.addEventListener("click", () => {
    const drawer = document.querySelector("[data-marketplace-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  });
});

document.querySelectorAll("[data-drawer-close]").forEach((trigger) => {
  trigger.addEventListener("click", fermerFilters);
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") fermerFilters();
});

// Drawer : cases à cocher (visuel)
document.querySelectorAll("[data-marketplace-drawer] .marketplace-drawer__check input[type='checkbox']").forEach((cb) => {
  cb.addEventListener("change", () => {
    cb.closest(".marketplace-drawer__check")?.classList.toggle("is-active", cb.checked);
  });
});

// Drawer : accordéons (titre de groupe → déploie/replie le panneau)
document.querySelectorAll("[data-acc-toggle]").forEach((btn) => {
  btn.addEventListener("click", () => {
    const group = btn.closest("[data-acc-group]");
    const panel = group?.querySelector("[data-acc-panel]");
    if (!panel) return;
    const open = panel.hasAttribute("hidden");
    if (open) { panel.removeAttribute("hidden"); } else { panel.setAttribute("hidden", ""); }
    btn.setAttribute("aria-expanded", String(open));
    group.classList.toggle("is-open", open);
  });
});

// Drawer : application multi-sélection (construit l'URL de filtres par tags)
document.querySelector("[data-drawer-apply]")?.addEventListener("click", () => {
  const drawer = document.querySelector("[data-marketplace-drawer]");
  if (!drawer) return;
  const base = drawer.dataset.collectionUrl || window.location.pathname;
  const handles = Array.from(drawer.querySelectorAll("[data-tag-handle]:checked")).map((c) => c.dataset.tagHandle);
  const sort = new URLSearchParams(window.location.search).get("sort_by");
  let url = base + (handles.length ? "/" + handles.join("+") : "");
  if (sort) url += "?sort_by=" + encodeURIComponent(sort);
  window.location.href = url;
});

// Barre : pills → dropdown direct (sans ouvrir le drawer)
document.querySelectorAll("[data-bar-toggle]").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const dd = btn.parentElement.querySelector("[data-bar-dropdown]");
    const isOpen = dd && !dd.hidden;
    document.querySelectorAll("[data-bar-dropdown]").forEach((d) => { d.hidden = true; });
    document.querySelectorAll("[data-bar-toggle]").forEach((b) => b.setAttribute("aria-expanded", "false"));
    if (dd && !isOpen) { dd.hidden = false; btn.setAttribute("aria-expanded", "true"); }
  });
});
document.addEventListener("click", (e) => {
  if (!e.target.closest("[data-bar-group]")) {
    document.querySelectorAll("[data-bar-dropdown]").forEach((d) => { d.hidden = true; });
  }
});

// Recherche dans un groupe de filtres (Marque, Vendeur) — filtre les options à la frappe.
// Rend la liste scalable : on tape « lev » → seules les marques correspondantes restent.
document.querySelectorAll("[data-filter-search]").forEach((input) => {
  const scope = input.closest("[data-bar-dropdown], .marketplace-drawer__group");
  if (!scope) return;
  const noResult = scope.querySelector("[data-filter-noresult]");
  const getOptions = () => scope.querySelectorAll(".marketplace-filters__option, .marketplace-drawer__check");
  input.addEventListener("click", (e) => e.stopPropagation());
  input.addEventListener("input", () => {
    const q = input.value.trim().toLowerCase();
    let visible = 0;
    getOptions().forEach((opt) => {
      const match = !q || (opt.textContent || "").toLowerCase().includes(q);
      opt.style.display = match ? "" : "none";
      if (match) visible++;
    });
    if (noResult) noResult.hidden = visible > 0;
  });
});

// ─────────────────────────────────────────────────────────────
// Bouton flottant filtres : apparaît quand la barre n'est plus visible
// ─────────────────────────────────────────────────────────────
const floatBtn = document.querySelector("[data-filters-float]");
const filtersBar = document.querySelector("[data-filters-bar]");
if (floatBtn && filtersBar && "IntersectionObserver" in window) {
  const obs = new IntersectionObserver(
    ([entry]) => floatBtn.classList.toggle("is-visible", !entry.isIntersecting),
    { rootMargin: "0px 0px -10px 0px", threshold: 0 }
  );
  obs.observe(filtersBar);
}

document.querySelectorAll("[data-sdv-sort-select]").forEach((select) => {
  select.addEventListener("change", () => {
    select.form?.submit();
  });
});

// ─────────────────────────────────────────────────────────────
// Favoris — localStorage
// ─────────────────────────────────────────────────────────────
const FAV_KEY = "sdv_favorites";

function loadFavs() {
  try { return JSON.parse(localStorage.getItem(FAV_KEY) || "[]"); }
  catch { return []; }
}

function saveFavs(favs) {
  localStorage.setItem(FAV_KEY, JSON.stringify(favs));
}

function isFaved(variantId) {
  return loadFavs().some((f) => String(f.id) === String(variantId));
}

function toggleFav(variantId, data) {
  const favs = loadFavs();
  const idx = favs.findIndex((f) => String(f.id) === String(variantId));
  if (idx >= 0) { favs.splice(idx, 1); }
  else { favs.push({ id: variantId, ...data }); }
  saveFavs(favs);
  return idx < 0;
}

/**
 * Publie l'ajout aux favoris dans le bus d'événements Shopify.
 * Le pixel personnalisé « SDV Marketplace » s'y abonne pour prévenir Meta.
 */
function publierFavori(variantId, heart, data) {
  try {
    window.Shopify?.analytics?.publish?.("sdv_favori_ajoute", {
      variantId: String(variantId),
      title: data.title || "",
      vendor: data.vendor || "",
      cents: Number(heart.dataset.favCents || 0),
      currency: heart.dataset.favCurrency || "EUR",
    });
  } catch {
    // Le favori reste enregistré même si la publication échoue.
  }
}

function initHearts() {
  document.querySelectorAll("[data-sdv-fav]").forEach((heart) => {
    const variantId = heart.dataset.sdvFav;
    heart.classList.toggle("is-liked", isFaved(variantId));

    if (heart.dataset.favBound) return;
    heart.dataset.favBound = "1";

    heart.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const data = {
        handle: heart.dataset.favHandle,
        url: heart.dataset.favUrl,
        title: heart.dataset.favTitle,
        price: heart.dataset.favPrice,
        imageUrl: heart.dataset.favImage,
        vendor: heart.dataset.favVendor,
      };
      const added = toggleFav(variantId, data);
      document.querySelectorAll(`[data-sdv-fav="${variantId}"]`)
        .forEach((h) => h.classList.toggle("is-liked", added));
      // Signal d'intention fort : on le publie pour le pixel marketplace, qui
      // le relaie à Meta. Uniquement à l'ajout, pas au retrait.
      if (added) publierFavori(variantId, heart, data);
    });
  });
}

initHearts();
window.sdvInitHearts = initHearts;

// ─────────────────────────────────────────────────────────────
// Recherche — pré-remplir le champ depuis l'URL
// ─────────────────────────────────────────────────────────────
const searchInput = document.querySelector("[data-sdv-search-input]");
if (searchInput) {
  const q = new URLSearchParams(location.search).get("q");
  if (q) searchInput.value = q;
}

// ─────────────────────────────────────────────────────────────
// Échec de chargement d'une messagerie
// Les trois écrans de fil avalaient les erreurs d'API en silence et affichaient
// « aucun message » quoi qu'il arrive : un vendeur simplement déconnecté croyait
// sa messagerie vide, sans rien pour le détromper. On nomme désormais la cause.
// ─────────────────────────────────────────────────────────────
function sdvErreurFil(erreur) {
  const statut = erreur && erreur.statut;
  if (statut === 401 || statut === 403) {
    const retour = encodeURIComponent(window.location.pathname + window.location.search);
    return `<span class="sdv-msg-alerte">${SDV_T("msg.sessionExpiree", "Votre session a expiré : reconnectez-vous pour retrouver vos messages.")}
      <a href="/account/login?return_to=${retour}">${SDV_T("msg.reconnexion", "Se reconnecter")}</a></span>`;
  }
  if (statut === 404) {
    return `<span class="sdv-msg-alerte">${SDV_T("msg.sansBoutique", "Aucune boutique n'est associée à ce compte. Écrivez-nous si c'est une erreur.")}</span>`;
  }
  return `<span class="sdv-msg-alerte">${SDV_T("msg.erreurChargement", "Vos messages n'ont pas pu être chargés. Réessayez dans un instant.")}</span>`;
}

// ─────────────────────────────────────────────────────────────
// Offres affichées dans le fil de discussion (style Vinted)
// Une offre n'est plus un objet à part : elle apparaît dans la conversation
// de l'annonce, avec ses boutons, et la discussion continue juste en dessous.
// Ces fonctions sont partagées par les trois écrans qui affichent un fil :
// le centre de messages, l'onglet Messages du vendeur et l'espace acheteur.
// ─────────────────────────────────────────────────────────────
function sdvEscOffre(v) {
  return String(v == null ? "" : v)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;")
    .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

function sdvEurosOffre(cents) {
  return (Number(cents || 0) / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
}

function sdvStatutOffre(statut) {
  const labels = {
    EN_ATTENTE: SDV_T("offer.st.pending", "En attente du vendeur"),
    ACCEPTEE: SDV_T("offerB.st.toPay", "Acceptée — à payer"),
    REFUSEE: SDV_T("offer.st.refused", "Refusée"),
    CONTRE_PROPOSEE: SDV_T("offerB.st.countered", "Contre-proposition en cours"),
    CONTRE_ACCEPTEE: SDV_T("offerB.st.toPay", "Acceptée — à payer"),
    CONTRE_REFUSEE: SDV_T("offer.st.refused", "Refusée"),
    PAYEE: SDV_T("offer.st.paid", "Payée ✓"),
    EXPIREE: SDV_T("offer.st.expired", "Expirée"),
    ANNULEE: SDV_T("offer.st.cancelled", "Annulée"),
  };
  return labels[statut] || statut;
}

// Les boutons dépendent du rôle ET du statut : le vendeur agit sur une offre
// en attente, l'acheteur sur une contre-proposition ou pour payer.
function sdvActionsOffre(offre, role) {
  const btn = (attrs, label, accent) =>
    `<button type="button" class="sdv-offre__btn${accent ? " sdv-offre__btn--accept" : ""}" ${attrs}>${label}</button>`;

  if (role === "seller" && offre.statut === "EN_ATTENTE") {
    return `<div class="sdv-msg-offre__actions">
      ${btn(`data-offre-act="accepter" data-offre-id="${offre.id}"`, `${SDV_T("common.accept", "Accepter")} ${sdvEurosOffre(offre.montant)}`, true)}
      ${btn(`data-offre-act="refuser" data-offre-id="${offre.id}"`, SDV_T("common.refuse", "Refuser"))}
      ${btn(`data-offre-act="contre-toggle" data-offre-id="${offre.id}"`, SDV_T("offer.counter", "Contre-proposer"))}
    </div>
    <div class="sdv-msg-offre__counter" data-offre-counter="${offre.id}" hidden>
      <input type="number" step="1" min="1" data-offre-counter-input="${offre.id}" placeholder="${SDV_T("offer.yourPrice", "Votre prix")}">
      ${btn(`data-offre-act="contre" data-offre-id="${offre.id}"`, SDV_T("common.send", "Envoyer"), true)}
      <p class="sdv-offre-gain__simu" data-offre-simu="${offre.id}" aria-live="polite"></p>
    </div>`;
  }

  if (role === "buyer" && offre.statut === "CONTRE_PROPOSEE" && offre.contreMontant != null) {
    return `<div class="sdv-msg-offre__actions">
      ${btn(`data-offre-act="accepter-contre" data-offre-id="${offre.id}"`, `${SDV_T("common.accept", "Accepter")} ${sdvEurosOffre(offre.contreMontant)}`, true)}
      ${btn(`data-offre-act="refuser-contre" data-offre-id="${offre.id}"`, SDV_T("common.refuse", "Refuser"))}
    </div>`;
  }

  if (role === "buyer" && offre.statut === "EN_ATTENTE") {
    return `<div class="sdv-msg-offre__actions">
      ${btn(`data-offre-act="annuler" data-offre-id="${offre.id}"`, SDV_T("offerB.cancel", "Annuler mon offre"))}
    </div>`;
  }

  if (role === "buyer" && (offre.statut === "ACCEPTEE" || offre.statut === "CONTRE_ACCEPTEE") && offre.checkoutUrl) {
    const montant = offre.contreMontant || offre.montant;
    return `<div class="sdv-msg-offre__actions">
      <a class="sdv-offre__btn sdv-offre__btn--accept" href="${sdvEscOffre(offre.checkoutUrl)}">${SDV_T("common.pay", "Payer")} ${sdvEurosOffre(montant)}</a>
    </div>`;
  }

  return "";
}

// ─── Ce que le vendeur touche sur une offre ───────────────────────────────
// Le montant vient du serveur (même calcul que les virements) : on ne refait
// pas la commission ici, pour qu'il ne puisse jamais différer du versement.
// Le serveur ne l'envoie qu'au vendeur.
const SDV_OFFRES_CLOSES = ["REFUSEE", "CONTRE_REFUSEE", "EXPIREE", "ANNULEE"];

function sdvPctOffre(bps) {
  return (Number(bps || 0) / 100).toLocaleString("fr-FR", { maximumFractionDigits: 2 }) + " %";
}

function sdvGainOffreHtml(offre) {
  const g = offre && offre.gainVendeur;
  if (!g || SDV_OFFRES_CLOSES.indexOf(offre.statut) !== -1) return "";
  const surContre = (offre.statut === "CONTRE_PROPOSEE" || offre.statut === "CONTRE_ACCEPTEE") && g.contre;
  const gain = surContre ? g.contre : g.montant;
  if (!gain) return "";
  let intro = SDV_T("offer.gain.received", "Vous recevrez");
  if (offre.statut === "EN_ATTENTE") intro = SDV_T("offer.gain.ifAccept", "Si vous acceptez, vous recevez");
  else if (offre.statut === "CONTRE_PROPOSEE") intro = SDV_T("offer.gain.ifCounter", "Si l'acheteur accepte votre contre-proposition, vous recevez");
  const ligne = (libelle, montant, retenue) =>
    `<li><span>${libelle}</span><span>${retenue ? "− " : ""}${sdvEurosOffre(montant)}</span></li>`;
  return `<div class="sdv-offre-gain">
    <p class="sdv-offre-gain__net">${intro} <strong>${sdvEurosOffre(gain.netCents)}</strong></p>
    <details class="sdv-offre-gain__detail">
      <summary>${SDV_T("offer.gain.detail", "Voir le détail")}</summary>
      <ul>
        ${ligne(SDV_T("offer.gain.price", "Prix de vente"), gain.prixCents, false)}
        ${ligne(`${SDV_T("offer.gain.commission", "Commission Salon du Vintage")} (${sdvPctOffre(gain.tauxBps)})`, gain.commissionCents, true)}
        ${ligne(`${SDV_T("offer.gain.fees", "Frais de traitement")} (${sdvPctOffre(gain.fraisBps)})`, gain.fraisCents, true)}
        ${gain.expertCents > 0 ? ligne(SDV_T("offer.gain.expert", "Service Expert"), gain.expertCents, true) : ""}
      </ul>
    </details>
  </div>`;
}

/**
 * Contre-proposition : affiche ce que le vendeur recevrait pendant qu'il tape.
 * `api` est le client HTTP de l'écran appelant. Branché une seule fois par
 * zone, même si l'écran se redessine.
 */
function sdvBrancherSimulationContre(scope, selecteurChamp, attributId, api) {
  if (!scope || scope.dataset.simulationContre) return;
  scope.dataset.simulationContre = "1";
  let minuteur = null;
  scope.addEventListener("input", (event) => {
    const champ = event.target.closest(selecteurChamp);
    if (!champ) return;
    const id = champ.getAttribute(attributId);
    const sortie = scope.querySelector(`[data-offre-simu="${id}"]`);
    if (!sortie) return;
    const valeur = parseFloat(String(champ.value || "").replace(",", "."));
    clearTimeout(minuteur);
    if (!(valeur > 0)) { sortie.textContent = ""; return; }
    minuteur = setTimeout(async () => {
      try {
        const reponse = await api(`/seller/offres/${id}/simulation?prix=${Math.round(valeur * 100)}`, "GET");
        // Le vendeur a pu continuer à taper pendant l'appel : on n'affiche que le dernier prix.
        if (parseFloat(String(champ.value || "").replace(",", ".")) !== valeur) return;
        sortie.innerHTML = `${SDV_T("offer.gain.wouldReceive", "Vous recevriez")} <strong>${sdvEurosOffre(reponse.gain.netCents)}</strong>`;
      } catch (e) {
        sortie.textContent = "";
      }
    }, 300);
  });
}

function sdvCarteOffre(offre, role) {
  if (!offre) return "";
  const contre = offre.contreMontant != null
    ? `<span class="sdv-msg-offre__counter-amount">${SDV_T("offer.counterShort", "Contre")} : ${sdvEurosOffre(offre.contreMontant)}</span>`
    : "";
  return `<div class="sdv-msg-offre" data-offre-card="${offre.id}">
    <p class="sdv-msg-offre__label">${SDV_T("offer.title", "Offre")}</p>
    <p class="sdv-msg-offre__amount"><strong>${sdvEurosOffre(offre.montant)}</strong><span class="sdv-msg-offre__old">${sdvEurosOffre(offre.prixOriginal)}</span>${contre}</p>
    <p class="sdv-msg-offre__status">${sdvEscOffre(sdvStatutOffre(offre.statut))}</p>
    ${role === "seller" ? sdvGainOffreHtml(offre) : ""}
    ${sdvActionsOffre(offre, role)}
  </div>`;
}

/** Rendu d'un fil complet : bulles de texte, cartes d'offre et lignes d'historique. */
function sdvRendreMessages(messages, selfAuthor, role) {
  return (messages || []).map((m) => {
    if (m.type === "OFFRE") return sdvCarteOffre(m.offre, role);
    if (m.type === "SYSTEME") {
      return `<p class="sdv-msg-systeme">${sdvEscOffre(m.corps)}</p>`;
    }
    const cote = m.auteur === selfAuthor ? "SELF" : "OTHER";
    return `<div class="sdv-msg-bubble sdv-msg-bubble--${cote}">${sdvEscOffre(m.corps)}<span class="sdv-msg-bubble__date">${sdvDateOffre(m.createdAt)}</span></div>`;
  }).join("");
}

function sdvDateOffre(iso) {
  try { return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short" }); } catch (e) { return ""; }
}

/**
 * Branche les boutons des cartes d'offre d'un fil. `api` et `rafraichir` sont
 * fournis par l'écran appelant : chacun a déjà son client HTTP et sa façon de
 * recharger la liste des conversations.
 */
function sdvBrancherOffres(scope, role, api, rafraichir) {
  if (!scope) return;
  if (role === "seller") sdvBrancherSimulationContre(scope, "[data-offre-counter-input]", "data-offre-counter-input", api);
  scope.querySelectorAll("[data-offre-act]").forEach((bouton) => {
    bouton.addEventListener("click", async () => {
      const id = bouton.dataset.offreId;
      const action = bouton.dataset.offreAct;

      if (action === "contre-toggle") {
        const zone = scope.querySelector(`[data-offre-counter="${id}"]`);
        if (zone) zone.hidden = !zone.hidden;
        return;
      }

      let chemin = null;
      let corps = {};
      if (action === "accepter" || action === "refuser") {
        chemin = `/seller/offres/${id}/${action}`;
      } else if (action === "contre") {
        const champ = scope.querySelector(`[data-offre-counter-input="${id}"]`);
        const valeur = parseFloat(String(champ?.value || "").replace(",", "."));
        if (!(valeur > 0)) return;
        chemin = `/seller/offres/${id}/contre`;
        corps = { contreMontant: valeur };
      } else {
        chemin = `/offres/${id}/${action}`;
      }

      bouton.disabled = true;
      try {
        await api(chemin, "POST", corps);
        await rafraichir();
      } catch (err) {
        alert(err.message || SDV_T("common.error", "Erreur"));
        bouton.disabled = false;
      }
    });
  });
}

// ─────────────────────────────────────────────────────────────
// Page produit : galerie + accordéon unique
// ─────────────────────────────────────────────────────────────
const productGallery = document.querySelector("[data-product-gallery]");
const productThumbs = [...document.querySelectorAll("[data-product-thumb]")];

if (productGallery && productThumbs.length) {
  const slides = [...productGallery.querySelectorAll(".product-gallery__main")];

  function setActiveThumb(index) {
    productThumbs.forEach((thumb, i) => thumb.classList.toggle("is-active", i === index));
  }

  productThumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const index = Number(thumb.dataset.productThumb || 0);
      slides[index]?.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      setActiveThumb(index);
    });
  });

  productGallery.addEventListener("scroll", () => {
    const index = Math.round(productGallery.scrollLeft / Math.max(1, productGallery.clientWidth));
    setActiveThumb(Math.max(0, Math.min(index, productThumbs.length - 1)));
  }, { passive: true });
}

// ─────────────────────────────────────────────────────────────
// Page produit : visionneuse plein écran (lightbox)
// Le détail d'une pièce vintage se joue sur la matière et l'usure : la vignette
// de la fiche ne suffit pas. L'image est affichée en « contain », donc au ratio
// d'origine, sans recadrage ni déformation.
// ─────────────────────────────────────────────────────────────
(function () {
  const zoomables = [...document.querySelectorAll(".product-gallery__main[data-zoom-src]")];
  if (!zoomables.length) return;

  const sources = zoomables.map((img) => ({
    src: img.dataset.zoomSrc || img.currentSrc || img.src,
    alt: img.alt || "",
  }));

  let index = 0;
  let ouvreur = null;
  let boite = null;

  function construire() {
    boite = document.createElement("div");
    boite.className = "sdv-lightbox";
    boite.setAttribute("role", "dialog");
    boite.setAttribute("aria-modal", "true");
    boite.setAttribute("aria-label", "Photo en plein écran");
    boite.innerHTML = `
      <button type="button" class="sdv-lightbox__close" aria-label="Fermer">&#10005;</button>
      <button type="button" class="sdv-lightbox__nav sdv-lightbox__nav--prev" aria-label="Photo précédente">&#8592;</button>
      <figure class="sdv-lightbox__stage"><img alt=""></figure>
      <button type="button" class="sdv-lightbox__nav sdv-lightbox__nav--next" aria-label="Photo suivante">&#8594;</button>
      <p class="sdv-lightbox__count" aria-live="polite"></p>`;
    document.body.appendChild(boite);

    boite.querySelector(".sdv-lightbox__close").addEventListener("click", fermer);
    boite.querySelector(".sdv-lightbox__nav--prev").addEventListener("click", () => aller(-1));
    boite.querySelector(".sdv-lightbox__nav--next").addEventListener("click", () => aller(1));
    // Un clic à côté de la photo referme, mais pas un clic sur la photo
    // elle-même : on ne veut pas fermer la visionneuse en voulant l'observer.
    boite.addEventListener("click", (event) => {
      if (event.target === boite || event.target.classList.contains("sdv-lightbox__stage")) fermer();
    });

    let departX = null;
    boite.addEventListener("touchstart", (e) => { departX = e.changedTouches[0].clientX; }, { passive: true });
    boite.addEventListener("touchend", (e) => {
      if (departX === null) return;
      const delta = e.changedTouches[0].clientX - departX;
      if (Math.abs(delta) > 50) aller(delta < 0 ? 1 : -1);
      departX = null;
    }, { passive: true });
  }

  function afficher() {
    const img = boite.querySelector(".sdv-lightbox__stage img");
    img.src = sources[index].src;
    img.alt = sources[index].alt;
    const compteur = boite.querySelector(".sdv-lightbox__count");
    compteur.textContent = sources.length > 1 ? `${index + 1} / ${sources.length}` : "";
    boite.classList.toggle("sdv-lightbox--seule", sources.length < 2);
  }

  function aller(pas) {
    index = (index + pas + sources.length) % sources.length;
    afficher();
  }

  function ouvrir(depuis, declencheur) {
    if (!boite) construire();
    index = depuis;
    ouvreur = declencheur || null;
    afficher();
    document.body.classList.add("sdv-lightbox-ouverte");
    boite.classList.add("is-open");
    boite.querySelector(".sdv-lightbox__close").focus();
    document.addEventListener("keydown", auClavier);
  }

  function fermer() {
    if (!boite) return;
    boite.classList.remove("is-open");
    document.body.classList.remove("sdv-lightbox-ouverte");
    document.removeEventListener("keydown", auClavier);
    // Le focus revient sur la photo d'où l'on vient, sinon la navigation au
    // clavier repart du haut de la page.
    if (ouvreur) ouvreur.focus();
  }

  function auClavier(event) {
    if (event.key === "Escape") fermer();
    else if (event.key === "ArrowRight") aller(1);
    else if (event.key === "ArrowLeft") aller(-1);
  }

  zoomables.forEach((img, i) => {
    img.addEventListener("click", () => ouvrir(i, img));
    img.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") { event.preventDefault(); ouvrir(i, img); }
    });
  });
})();

document.querySelectorAll(".product-accordion details").forEach((detail) => {
  detail.addEventListener("toggle", () => {
    if (!detail.open) return;
    document.querySelectorAll(".product-accordion details").forEach((other) => {
      if (other !== detail) other.removeAttribute("open");
    });
  });
});

// ─────────────────────────────────────────────────────────────
// Page vendeur : onglets articles / avis
// ─────────────────────────────────────────────────────────────
const vendorTabs = [...document.querySelectorAll("[data-vendor-tab]")];
const vendorPanels = [...document.querySelectorAll("[data-vendor-panel]")];

if (vendorTabs.length && vendorPanels.length) {
  function activateVendorTab(target) {
    vendorTabs.forEach((tab) => {
      const isActive = tab.dataset.vendorTab === target;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });

    vendorPanels.forEach((panel) => {
      panel.hidden = panel.dataset.vendorPanel !== target;
    });
  }

  vendorTabs.forEach((tab) => {
    tab.addEventListener("click", () => activateVendorTab(tab.dataset.vendorTab));
  });

  const hashTarget = window.location.hash ? window.location.hash.replace("#", "") : "";
  if (hashTarget && vendorPanels.some((panel) => panel.dataset.vendorPanel === hashTarget)) {
    activateVendorTab(hashTarget);
  }
}

// ─────────────────────────────────────────────────────────────
// Header : badge messages connecté
// ─────────────────────────────────────────────────────────────
(function () {
  const links = [...document.querySelectorAll("[data-sdv-header-messages]")];
  if (!links.length) return;

  const proxyBase = "/apps/sdv-marketplace";

  async function json(path) {
    const response = await fetch(proxyBase + path, { credentials: "same-origin" });
    if (!response.ok) return null;
    return response.json().catch(() => null);
  }

  Promise.allSettled([
    json("/customer/conversations"),
    json("/seller/conversations"),
  ]).then((results) => {
    const buyer = results[0].status === "fulfilled" ? results[0].value?.conversations || [] : [];
    const seller = results[1].status === "fulfilled" ? results[1].value?.conversations || [] : [];
    const buyerUnread = buyer.filter((conversation) => conversation?.nonLuAcheteur).length;
    const sellerUnread = seller.filter((conversation) => conversation?.nonLuVendeur).length;
    const totalUnread = buyerUnread + sellerUnread;
    const targetUrl = sellerUnread > buyerUnread ? "/pages/messages#seller" : "/pages/messages";

    links.forEach((link) => {
      link.setAttribute("href", targetUrl);
    });

    document.querySelectorAll("[data-sdv-header-messages-count]").forEach((badge) => {
      if (totalUnread > 0) {
        badge.textContent = totalUnread > 9 ? "9+" : String(totalUnread);
        badge.hidden = false;
        badge.classList.add("is-visible");
      } else {
        badge.hidden = true;
        badge.classList.remove("is-visible");
      }
    });
  });
})();

// ─────────────────────────────────────────────────────────────
// Centre messages : conversations acheteur + vendeur
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector("[data-sdv-message-center]");
  if (!root) return;

  const proxyBase = (root.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const tabs = [...root.querySelectorAll("[data-message-role]")];
  const badges = {
    buyer: root.querySelector('[data-message-role-badge="buyer"]'),
    seller: root.querySelector('[data-message-role-badge="seller"]'),
  };
  const list = root.querySelector("[data-message-center-list]");
  const empty = root.querySelector("[data-message-center-empty]");
  const thread = root.querySelector("[data-message-center-thread]");
  const state = {
    role: window.location.hash === "#seller" ? "seller" : "buyer",
    buyer: [],
    seller: [],
    activeId: null,
  };

  function esc(s) {
    return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function dt(iso) {
    try {
      return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
    } catch {
      return "";
    }
  }

  async function api(path, method, body) {
    const response = await fetch(proxyBase + path, {
      method: method || "GET",
      credentials: "same-origin",
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      // Le code HTTP dit s'il s'agit d'une session tombée (401) ou d'une panne.
      const erreur = new Error(data.erreur || "Erreur de chargement.");
      erreur.statut = response.status;
      throw erreur;
    }
    return data;
  }

  function endpoint(role, id, reply) {
    const base = role === "seller" ? "/seller/conversations" : "/customer/conversations";
    if (!id) return base;
    return `${base}/${id}${reply ? "/repondre" : ""}`;
  }

  function unreadCount(role) {
    const key = role === "seller" ? "nonLuVendeur" : "nonLuAcheteur";
    return state[role].filter((conversation) => conversation?.[key]).length;
  }

  function updateBadges() {
    ["buyer", "seller"].forEach((role) => {
      const count = unreadCount(role);
      const badge = badges[role];
      if (!badge) return;
      if (count > 0) {
        badge.textContent = count > 9 ? "9+" : String(count);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    });
  }

  function renderTabs() {
    tabs.forEach((tab) => {
      const active = tab.dataset.messageRole === state.role;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", String(active));
    });
  }

  function conversationTitle(conversation) {
    if (conversation._role === "seller") return conversation.acheteurNom || "Acheteur";
    return conversation.sellerName || conversation.productTitle || "Conversation";
  }

  // Liste unifiée : conversations acheteur + vendeur fusionnées, triées par date.
  // Chaque conversation porte son rôle (_role) pour ouvrir le bon fil/endpoint.
  function mergedConversations() {
    const withRole = (arr, role) => (arr || []).map((c) => ({ ...c, _role: role }));
    return [...withRole(state.buyer, "buyer"), ...withRole(state.seller, "seller")]
      .sort((a, b) => new Date(b.dernierMessageAt || 0) - new Date(a.dernierMessageAt || 0));
  }

  function renderList() {
    const conversations = mergedConversations();

    if (!conversations.length) {
      list.innerHTML = "";
      // Une boîte vide et une boîte inaccessible se ressemblaient : on distingue.
      const echec = state.erreur ? sdvErreurFil(state.erreur) : "";
      if (empty) {
        empty.innerHTML = echec || SDV_T("msg.empty", "Aucune conversation pour l'instant. Vos échanges apparaîtront ici.");
        empty.hidden = false;
      }
      thread.innerHTML =
        '<div class="sdv-msg-thread__empty sdv-msg-empty">' +
        '<span class="sdv-msg-empty__icon"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 5.5h16v11H8.4L4 20V5.5Z"/><path d="M8 9h8M8 13h5"/></svg></span>' +
        (echec
          ? '<p class="sdv-msg-empty__title">' + SDV_T("msg.indisponible", "Messagerie indisponible") + '</p><p class="sdv-msg-empty__text">' + echec + '</p>'
          : '<p class="sdv-msg-empty__title">Aucune conversation</p>' +
            '<p class="sdv-msg-empty__text">Vos échanges avec les acheteurs et les vendeurs apparaîtront ici.</p>') +
        '</div>';
      return;
    }

    if (empty) empty.hidden = true;
    list.innerHTML = conversations.map((conversation) => {
      const unread = conversation._role === "seller" ? conversation.nonLuVendeur : conversation.nonLuAcheteur;
      const active = String(conversation.id) === String(state.activeId);
      return `<button class="sdv-msg-card${unread ? " is-unread" : ""}${active ? " is-active" : ""}" data-center-conv="${conversation.id}" data-center-role="${conversation._role}">
        <span class="sdv-msg-card__top">
          <span class="sdv-msg-card__name">${esc(conversationTitle(conversation))}</span>
          <span class="sdv-msg-card__date">${dt(conversation.dernierMessageAt)}</span>
        </span>
        ${conversation.productTitle ? `<span class="sdv-msg-card__product">${esc(conversation.productTitle)}</span>` : ""}
      </button>`;
    }).join("");
  }

  function renderThread(conversation) {
    const role = conversation._role;
    const self = role === "seller" ? "VENDEUR" : "ACHETEUR";
    thread.innerHTML = `<header class="sdv-msg-thread__head">
        <div>
          <p class="sdv-msg-thread__label">Conversation</p>
          <h2>${esc(conversationTitle(conversation))}</h2>
        </div>
        ${conversation.productTitle ? `<span>${esc(conversation.productTitle)}</span>` : ""}
      </header>
      <div class="sdv-msg-bubbles">
        ${sdvRendreMessages(conversation.messages, self, role === "seller" ? "seller" : "buyer")}
      </div>
      <div class="sdv-msg-reply">
        <textarea data-center-reply placeholder="Votre message..."></textarea>
        <button data-center-send>Envoyer</button>
      </div>`;

    // Les cartes d'offre du fil agissent sur les mêmes routes que l'onglet Offres.
    sdvBrancherOffres(thread, role === "seller" ? "seller" : "buyer", api, async () => {
      await openConversation(state.activeId, role);
    });

    thread.querySelector("[data-center-send]")?.addEventListener("click", async (ev) => {
      const bouton = ev.currentTarget;
      const textarea = thread.querySelector("[data-center-reply]");
      const message = (textarea?.value || "").trim();
      if (!message) return;
      bouton.disabled = true;
      try {
        const res = await api(endpoint(role, state.activeId, true), "POST", { message });
        if (res && res.coordonneesMasquees) alert(SDV_AVERTISSEMENT_COORDONNEES);
        await openConversation(state.activeId, role);
      } catch (error) {
        alert(error.message || SDV_T("common.sendError", "Envoi impossible."));
        bouton.disabled = false;
      }
    });
  }

  async function loadRole(role) {
    try {
      const data = await api(endpoint(role));
      state[role] = data.conversations || [];
      state.erreur = null;
    } catch (error) {
      state[role] = [];
      state.erreur = error;
    }
    renderList();
  }

  async function openConversation(id, role) {
    state.activeId = id;
    try {
      const data = await api(endpoint(role, id));
      renderThread({ ...data.conversation, _role: role });
      await loadRole(role);
    } catch (error) {
      // Même traitement que les autres écrans : « Conversation introuvable »
      // était trompeur quand la vraie cause était une session tombée.
      thread.innerHTML = `<p class="sdv-msg-thread__empty">${sdvErreurFil(error)}</p>`;
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      state.role = tab.dataset.messageRole;
      state.activeId = null;
      const baseUrl = window.location.pathname + window.location.search;
      window.history.replaceState(null, "", state.role === "seller" ? `${baseUrl}#seller` : baseUrl);
      renderList();
    });
  });

  list?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-center-conv]");
    if (button) openConversation(button.dataset.centerConv, button.dataset.centerRole);
  });

  const isVendor = root.dataset.isVendor === "true";
  const rolesToLoad = isVendor ? [loadRole("buyer"), loadRole("seller")] : [loadRole("buyer")];
  // Si non vendeur, forcer le rôle acheteur même si le hash disait #seller
  if (!isVendor) state.role = "buyer";

  Promise.allSettled(rolesToLoad).then(() => {
    renderList();
  });
})();

// ─────────────────────────────────────────────────────────────
// Page vendeur : avis (lecture publique + dépôt acheteur connecté)
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector("[data-vendor-reviews]");
  if (!root) return;
  const proxyBase = (root.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const handle = root.dataset.sellerHandle || "";

  const avgEl = document.querySelector("[data-reviews-avg]");
  const countEl = document.querySelector("[data-reviews-count]");
  const titleEl = root.querySelector("[data-reviews-title]");
  const listEl = root.querySelector("[data-reviews-list]");
  const emptyEl = root.querySelector("[data-reviews-empty]");
  const form = root.querySelector("[data-reviews-form]");
  const starsWrap = root.querySelector("[data-reviews-stars]");
  const commentEl = root.querySelector("[data-reviews-comment]");
  const statusEl = root.querySelector("[data-reviews-status]");
  let note = 0;

  function esc(s) {
    return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function stars(n) {
    let out = "";
    for (let i = 1; i <= 5; i++) out += `<span class="${i <= n ? "is-on" : ""}">★</span>`;
    return out;
  }
  function fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
    } catch { return ""; }
  }

  function render(data) {
    const total = data.total || 0;
    if (avgEl) avgEl.textContent = data.moyenne != null ? String(data.moyenne).replace(".", ",") : "—";
    if (countEl) countEl.textContent = total > 0 ? `avis (${total})` : "avis";
    if (titleEl) {
      titleEl.textContent = total > 0
        ? `${String(data.moyenne).replace(".", ",")}/5 sur ${total} avis.`
        : SDV_T("reviews.empty", "Aucun avis pour le moment.");
    }
    const avis = Array.isArray(data.avis) ? data.avis : [];
    if (listEl) {
      listEl.innerHTML = avis.map((a) => `
        <article class="vendor-review">
          <div class="vendor-review__stars">${stars(a.note)}</div>
          ${a.commentaire ? `<p class="vendor-review__text">${esc(a.commentaire)}</p>` : ""}
          <p class="vendor-review__meta">${esc(a.auteurNom)} · ${fmtDate(a.createdAt)}</p>
        </article>`).join("");
    }
    if (emptyEl) emptyEl.hidden = avis.length > 0;
    if (form && data.peutNoter) form.hidden = false;
  }

  fetch(`${proxyBase}/seller/avis?handle=${encodeURIComponent(handle)}`, { credentials: "same-origin" })
    .then((r) => (r.ok ? r.json() : { total: 0, avis: [], moyenne: null, peutNoter: false }))
    .then(render)
    .catch(() => {});

  // Notation par étoiles
  if (starsWrap) {
    starsWrap.querySelectorAll("[data-star]").forEach((btn) => {
      btn.addEventListener("click", () => {
        note = Number(btn.dataset.star) || 0;
        starsWrap.querySelectorAll("[data-star]").forEach((b) => {
          b.classList.toggle("is-on", Number(b.dataset.star) <= note);
        });
      });
    });
  }

  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (statusEl) statusEl.textContent = "";
      if (note < 1) { if (statusEl) statusEl.textContent = SDV_T("reviews.chooseRating", "Choisissez une note."); return; }
      const submit = form.querySelector("[type='submit']");
      submit?.setAttribute("disabled", "disabled");
      try {
        const res = await fetch(`${proxyBase}/seller/avis`, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sellerHandle: handle, note, commentaire: commentEl?.value || "" }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.erreur || SDV_T("common.sendError", "Envoi impossible."));
        form.hidden = true;
        if (statusEl) statusEl.textContent = "";
        // Recharger la liste
        const fresh = await fetch(`${proxyBase}/seller/avis?handle=${encodeURIComponent(handle)}`, { credentials: "same-origin" }).then((r) => r.json());
        render({ ...fresh, peutNoter: false });
      } catch (err) {
        if (statusEl) statusEl.textContent = err.message || SDV_T("common.sendError", "Envoi impossible.");
      } finally {
        submit?.removeAttribute("disabled");
      }
    });
  }
})();

// ─────────────────────────────────────────────────────────────
// Espace vendeur SDV : hydratation via Shopify App Proxy → Vercel → API SDV
// ─────────────────────────────────────────────────────────────
const sdvVendorDashboard = document.querySelector("[data-sdv-vendor-dashboard]");

if (sdvVendorDashboard) {
  const proxyBase = (sdvVendorDashboard.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const profileForm = sdvVendorDashboard.querySelector("[data-sdv-vendor-profile-form]");
  const profileStatus = sdvVendorDashboard.querySelector("[data-sdv-profile-status]");
  const avatarInput = sdvVendorDashboard.querySelector("[data-sdv-avatar-input]");
  const avatarPreview = sdvVendorDashboard.querySelector("[data-sdv-avatar-preview]");
  const avatarStatus = sdvVendorDashboard.querySelector("[data-sdv-avatar-status]");
  const specialtyInput = profileForm?.querySelector("[name='specialties']");
  const specialtyOptions = Array.from(sdvVendorDashboard.querySelectorAll("[data-sdv-specialty-option]"));
  const payoutForm = sdvVendorDashboard.querySelector("[data-sdv-payout-form]");
  const payoutStatus = sdvVendorDashboard.querySelector("[data-sdv-payout-status]");
  const payoutDisplay = sdvVendorDashboard.querySelector("[data-sdv-payout-display]");
  const payoutState = sdvVendorDashboard.querySelector("[data-sdv-payout-state]");

  function setVendorText(selector, value) {
    if (value === undefined || value === null || value === "") return;
    sdvVendorDashboard.querySelectorAll(selector).forEach((node) => {
      node.textContent = value;
    });
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function slugify(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function profileFieldMap(fields) {
    return Object.fromEntries((fields || []).map((field) => [field.key, field.value || ""]));
  }

  function setProfileInput(name, value) {
    const input = profileForm?.querySelector(`[name="${name}"]`);
    if (input && value !== undefined && value !== null) input.value = value;
  }

  function publicProfileFields(data) {
    return profileFieldMap(data.publicProfile?.metaobject?.fields);
  }

  function renderProfilePreview() {
    if (!profileForm) return;
    const formData = new FormData(profileForm);
    const name = String(formData.get("name") || "").trim() || "Vendeur";
    const city = String(formData.get("city") || "").trim();
    const country = String(formData.get("country") || "").trim() || "France";
    const location = city ? `${city}, ${country}` : country;
    const bio = String(formData.get("bio") || "").trim() || "Votre description apparaîtra ici sur la page publique.";
    const avatarUrl = String(formData.get("avatarUrl") || "").trim();
    const specialties = String(formData.get("specialties") || "Mode vintage,Objets rares")
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean)
      .slice(0, 3);

    const previewName = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-name]");
    const previewMeta = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-meta]");
    const previewBio = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-bio]");
    const previewAvatar = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-avatar]");
    const previewTags = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-tags]");

    if (previewName) previewName.textContent = name;
    if (previewMeta) previewMeta.textContent = `@${slugify(name) || "vendeur"} · ${location}`;
    if (previewBio) previewBio.textContent = bio;
    if (previewAvatar) {
      previewAvatar.innerHTML = avatarUrl
        ? `<img src="${escapeHtml(avatarUrl)}" alt="${escapeHtml(name)}" loading="lazy">`
        : escapeHtml(name.slice(0, 1).toUpperCase());
    }
    if (avatarPreview) {
      avatarPreview.innerHTML = avatarUrl
        ? `<img src="${escapeHtml(avatarUrl)}" alt="${escapeHtml(name)}" loading="lazy">`
        : escapeHtml(name.slice(0, 1).toUpperCase());
    }
    if (previewTags) {
      previewTags.innerHTML = specialties.map((tag) => `<span>${escapeHtml(tag)}</span>`).join("");
    }
  }

  function setProfileStatus(message, type) {
    if (!profileStatus) return;
    profileStatus.textContent = message || "";
    profileStatus.classList.toggle("is-error", type === "error");
    profileStatus.classList.toggle("is-success", type === "success");
  }

  function setAvatarStatus(message, type) {
    if (!avatarStatus) return;
    avatarStatus.textContent = message || "";
    avatarStatus.classList.toggle("is-error", type === "error");
    avatarStatus.classList.toggle("is-success", type === "success");
  }

  function setPayoutStatus(message, type) {
    if (!payoutStatus) return;
    payoutStatus.textContent = message || "";
    payoutStatus.classList.toggle("is-error", type === "error");
    payoutStatus.classList.toggle("is-success", type === "success");
  }

  function selectedSpecialties() {
    return String(specialtyInput?.value || "")
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean)
      .slice(0, 3);
  }

  function renderSpecialties() {
    const selected = selectedSpecialties();
    if (specialtyInput) specialtyInput.value = selected.join(",");
    specialtyOptions.forEach((button) => {
      const value = button.dataset.sdvSpecialtyOption || "";
      const isSelected = selected.includes(value);
      button.classList.toggle("is-selected", isSelected);
      button.classList.toggle("is-disabled", !isSelected && selected.length >= 3);
      button.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  }

  function dashboardFileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => reject(new Error(SDV_T("common.imageReadError", "Lecture de l'image impossible.")));
      reader.readAsDataURL(file);
    });
  }

  function renderProducts(products) {
    const list = sdvVendorDashboard.querySelector("[data-sdv-products-list]");
    const empty = sdvVendorDashboard.querySelector("[data-sdv-products-empty]");
    const emptyWrap = sdvVendorDashboard.querySelector("[data-sdv-products-empty-wrap]");

    if (!list) return;

    if (!Array.isArray(products) || products.length === 0) {
      list.innerHTML = "";
      list.hidden = true;
      if (emptyWrap) emptyWrap.hidden = false;
      if (empty) empty.textContent = SDV_T("vp.empty", "Vous n'avez pas encore de produits actifs.");
      return;
    }

    list.hidden = false;
    if (emptyWrap) emptyWrap.hidden = true;
    const countEl = sdvVendorDashboard.querySelector("[data-sdv-products-count]");
    if (countEl) {
      countEl.textContent = SDV_T("vp.count", `${products.length} article${products.length > 1 ? "s" : ""} en vente`, { n: products.length });
      countEl.hidden = false;
    }

    list.innerHTML = products.map((product) => {
      const id = escapeHtml(String(product.id ?? ""));
      const title = escapeHtml(product.title || "Produit");
      const vendor = escapeHtml(product.vendor || "");
      const rawPrice = product.price != null ? String(product.price) : "";
      const priceLabel = product.price ? `${escapeHtml(String(product.price))} €` : SDV_T("vp.priceTBD", "Prix à confirmer");
      const stock = product.quantity != null ? String(product.quantity) : "";
      const imageUrl = escapeHtml(product.imageUrl || "");
      const handle = escapeHtml(product.handle || "");
      const status = product.status || "En attente";
      const isActive = status === "Actif";
      const stockNum = product.quantity != null ? Number(product.quantity) : null;
      // Le retrait auprès du vendeur n'est pas ouvert sur la marketplace : les
      // deux modes qui le mentionnaient sont ramenés au parcours réel, domicile
      // ou point relais. Les clés sont conservées pour les annonces anciennes
      // encore enregistrées avec l'ancien mode.
      const shippingModes = {
        ship: SDV_T("ship.mode.ship", "Domicile ou point relais"),
        pickup: SDV_T("ship.mode.pickup", "Domicile ou point relais"),
        ship_or_pickup: SDV_T("ship.mode.ship_or_pickup", "Domicile ou point relais"),
        quote: SDV_T("ship.mode.quote", "Sur devis"),
      };
      const shippingTiers = {
        small: SDV_T("ship.tier.small", "petit colis"),
        medium: SDV_T("ship.tier.medium", "colis standard"),
        large: SDV_T("ship.tier.large", "grand colis"),
        fragile: SDV_T("ship.tier.fragile", "fragile"),
        furniture: SDV_T("ship.tier.furniture", "meuble / volumineux"),
      };
      const shippingLabel = product.shippingMode
        ? `${shippingModes[product.shippingMode] || SDV_T("ship.mode.default", "Livraison")} · ${shippingTiers[product.shippingTier] || SDV_T("ship.tier.default", "colis")}`
        : "";

      // Expiration de l'annonce
      const expiresAt = product.expiresAt ? new Date(product.expiresAt) : null;
      const expired = !!product.expired;
      const expSoon = !!(expiresAt && !expired && (expiresAt.getTime() - Date.now()) < 10 * 86400000);

      // Badge statut posé sur l'image — couleurs sémantiques maquette + classes thème
      let tagLabel = SDV_T("vp.tag.moderation", "En modération");
      let tagClass = "product-card__tag";
      let tagInline = "background: var(--warning, #b45309); color: #fff;";
      if (isActive && stockNum === 0) {
        tagLabel = SDV_T("vp.tag.sold", "Vendu");
        tagInline = "background: var(--pierre-700); color: #fff;";
      } else if (isActive) {
        tagLabel = SDV_T("vp.tag.published", "Publié");
        tagClass = "product-card__tag product-card__tag--love";
        tagInline = "";
      }
      if (expired) {
        tagLabel = SDV_T("vp.tag.expired", "Expirée");
        tagClass = "product-card__tag";
        tagInline = "background: var(--warning, #b45309); color: #fff;";
      }

      const expiryMeta = expired
        ? `<span class="product-card__meta" style="color:var(--warning,#b45309);font-weight:700;">Annonce expirée — à prolonger</span>`
        : expiresAt
          ? `<span class="product-card__meta"${expSoon ? ' style="color:var(--warning,#b45309);font-weight:700;"' : ""}>Expire le ${expiresAt.toLocaleDateString("fr-FR")}</span>`
          : "";
      const renewButton = (expired || expSoon)
        ? `<button type="button" class="is-primary" data-renew-product="${id}">Prolonger</button>`
        : "";

      const liveUrl = isActive && handle ? `/products/${handle}` : "";
      const liveButton = liveUrl
        ? `<a href="${liveUrl}" target="_blank" rel="noopener">Voir</a>`
        : "";

      const moderationStatut = product.moderationStatut || null;
      const moderationMessage = product.moderationMessage || null;
      const editUrl = `/pages/ajouter-produit?edit=${handle}`;

      // Produit publié = approuvé : on n'affiche plus la demande de modification,
      // même si un ancien tag de modération traîne encore côté Shopify.
      const revisionBanner = !isActive && moderationStatut === "revision-demandee" && moderationMessage
        ? `<div class="sdv-revision-banner">
            <div class="sdv-revision-banner__header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              <strong>Modifications demandées par notre équipe</strong>
            </div>
            <p class="sdv-revision-banner__message">${escapeHtml(moderationMessage)}</p>
            <a href="${editUrl}" class="sdv-revision-banner__cta">Modifier et resoumettre →</a>
          </div>`
        : !isActive && moderationStatut === "resoumis"
        ? `<div class="sdv-revision-banner sdv-revision-banner--resoumis">
            <div class="sdv-revision-banner__header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
              <strong>Annonce resoumise — en attente de validation</strong>
            </div>
          </div>`
        : "";

      return `
      <article class="product-card product-card--managed"
               data-product-id="${id}"
               data-title="${title}"
               data-price="${escapeHtml(rawPrice)}"
               data-stock="${escapeHtml(stock)}"
               data-handle="${handle}"
               data-moderation="${moderationStatut || ""}"
               data-active="${isActive ? "1" : "0"}">
        <div class="product-card__media">
          <span class="${tagClass}"${tagInline ? ` style="${tagInline}"` : ""}>${tagLabel}</span>
          ${
            imageUrl
              ? `<img src="${imageUrl}" alt="${title}" loading="lazy">`
              : `<div style="width:100%;aspect-ratio:4/5;background:var(--pierre-100);"></div>`
          }
        </div>
        <div class="product-card__info">
          ${vendor ? `<span class="product-card__brand">${vendor}</span>` : ""}
          <span class="product-card__title">${title}</span>
          ${revisionBanner}
          ${stock !== "" ? `<span class="product-card__meta">Stock : ${escapeHtml(stock)}</span>` : ""}
          ${shippingLabel ? `<span class="product-card__meta">${escapeHtml(shippingLabel)}</span>` : ""}
          ${expiryMeta}
          <div class="product-card__prices"><span class="product-card__price-now">${priceLabel}</span></div>
          <div class="product-card__manage">
            <button type="button" class="is-primary" data-edit-product>Modifier</button>
            ${renewButton}
            ${isActive ? `<button type="button" data-boost-product="${id}">Booster</button>` : ""}
            ${liveButton}
            ${isActive ? `<button type="button" data-remove-product="${id}" style="color:var(--error,#b91c1c);">${SDV_T("vp.remove", "Retirer (vendu ailleurs)")}</button>` : ""}
          </div>
        </div>
      </article>`;
    }).join("");
    if (typeof decorateProductBoosts === "function") decorateProductBoosts();
  }

  // ── Édition / suppression produit via modal ──
  const productModal = sdvVendorDashboard.querySelector("[data-sdv-product-modal]");
  const productEditForm = productModal?.querySelector("[data-sdv-product-edit-form]");
  let editingProductId = null;

  function resetDeleteConfirm() {
    const confirmBox = productModal?.querySelector("[data-edit-confirm]");
    const deleteBtn = productModal?.querySelector("[data-edit-delete]");
    if (confirmBox) confirmBox.hidden = true;
    if (deleteBtn) deleteBtn.hidden = false;
  }

  function openProductModal(card) {
    if (!productModal || !card) return;
    editingProductId = card.dataset.productId || null;
    // Mémorisé pour le lien « modifier les photos », qui ouvre le formulaire complet.
    productModal.dataset.handle = card.dataset.handle || "";
    const titleInput = productModal.querySelector("[data-edit-title]");
    const priceInput = productModal.querySelector("[data-edit-price]");
    const stockInput = productModal.querySelector("[data-edit-stock]");
    const statusNode = productModal.querySelector("[data-edit-status]");
    if (titleInput) titleInput.value = card.dataset.title || "";
    if (priceInput) priceInput.value = card.dataset.price || "";
    if (stockInput) stockInput.value = card.dataset.stock || "";
    if (statusNode) statusNode.textContent = "";
    resetDeleteConfirm();
    productModal.hidden = false;
    productModal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    titleInput?.focus();
  }

  function closeProductModal() {
    if (!productModal) return;
    productModal.hidden = true;
    productModal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    editingProductId = null;
    resetDeleteConfirm();
  }

  async function sendProductRequest(method, body) {
    const response = await fetch(`${proxyBase}/products/${editingProductId}/shopify`, {
      method,
      credentials: "same-origin",
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.erreur || SDV_T("common.opError", "Opération impossible."));
    return data;
  }

  // Depuis la modale rapide, accès au formulaire complet : c'est là que se
  // modifient photos et description. Le serveur remet alors l'annonce en
  // validation, l'interface le dit avant le clic.
  document.addEventListener("click", (event) => {
    const lien = event.target.closest("[data-edit-complet]");
    if (!lien) return;
    event.preventDefault();
    const handle = document.querySelector("[data-sdv-product-modal]")?.dataset.handle || "";
    if (!handle) return;
    const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    window.location.href = racine + "pages/ajouter-produit?edit=" + encodeURIComponent(handle);
  });

  const productsListEl = sdvVendorDashboard.querySelector("[data-sdv-products-list]");
  productsListEl?.addEventListener("click", (event) => {
    const boostBtn = event.target.closest("[data-boost-product]");
    if (boostBtn) { ouvrirBoostProduit(boostBtn.dataset.boostProduct); return; }
    const editBtn = event.target.closest("[data-edit-product]");
    if (!editBtn) return;
    const card = editBtn.closest(".product-card");
    // Produit en modération → édition complète (formulaire), pas la modale prix seul
    if (card?.dataset.moderation === "revision-demandee") {
      const h = card.dataset.handle || "";
      if (h) { window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "pages/ajouter-produit?edit=" + encodeURIComponent(h); return; }
    }
    openProductModal(card);
  });

  // ── Boost : config + boutique + picker produit ──
  let _boostCfg = null;
  let _boostsByProduct = {};
  fetch(proxyBase + "/config", { credentials: "same-origin" })
    .then((r) => (r.ok ? r.json() : {}))
    .then((cfg) => {
      // Le mode « vendeurs uniquement » coupe la mise en avant côté thème même si
      // l'API ne renvoie pas encore le drapeau (déploiement app décalé).
      const boost = cfg && cfg.boost ? Object.assign({}, cfg.boost) : null;
      if (boost && cfg.launchMode === "sellers_only") { boost.actif = false; boost.indisponibleRaison = "prelaunch"; }
      _boostCfg = boost;
      initBoostShop();
    })
    .catch(() => {});

  function decorateProductBoosts() {
    const cards = sdvVendorDashboard.querySelectorAll(".product-card--managed");
    cards.forEach((card) => {
      const id = card.dataset.productId;
      const b = id && _boostsByProduct[id];
      const info = card.querySelector(".product-card__info");
      if (!info) return;
      const existing = info.querySelector("[data-boost-state]");
      if (existing) existing.remove();
      if (!b) return;
      let html = "";
      if (b.statut === "PENDING" && b.checkoutUrl) {
        html = `<a class="sdv-boost-pay" data-boost-state href="${b.checkoutUrl}">★ Payer le boost</a>`;
      } else if (b.statut === "AWAITING_APPROVAL") {
        html = `<span class="sdv-boost-await" data-boost-state>★ Boost en attente de validation</span>`;
      } else if (b.statut === "ACTIVE") {
        html = `<span class="sdv-boost-active" data-boost-state>★ Annonce mise en avant</span>`;
      }
      if (html) {
        const priceline = info.querySelector(".product-card__manage") || info.lastElementChild;
        if (priceline) priceline.insertAdjacentHTML("beforebegin", html);
        else info.insertAdjacentHTML("beforeend", html);
      }
    });
  }

  // Formatage prix : centimes → « 34,80 € »
  function boostEuros(cents) {
    return (Number(cents || 0) / 100).toFixed(2).replace(".", ",") + " €";
  }

  // Prix du boost boutique. Le détail HT / TVA n'est affiché que si l'API le
  // fournit : sinon on montre le montant tel quel, jamais un TTC recalculé qui
  // différerait de la somme réellement débitée au checkout.
  function boostShopPrix() {
    const detaille = _boostCfg.sellerPriceTtcCents != null;
    const ttc = Number(detaille ? _boostCfg.sellerPriceTtcCents : _boostCfg.sellerMonthlyPriceCents) || 0;
    return {
      detaille: detaille,
      ttc: ttc,
      ht: Number(_boostCfg.sellerPriceHtCents) || 0,
      tva: Number(_boostCfg.sellerPriceTvaCents) || 0,
    };
  }

  /**
   * Ancre #mise-en-avant : l'encart n'est révélé qu'après le chargement de
   * /config, donc bien après que le navigateur a traité l'ancre. On fait
   * défiler nous-mêmes une fois qu'il est visible.
   */
  function rejoindreMiseEnAvant() {
    // Trois voies, parce qu'aucune n'est fiable seule : l'ancre disparaît lors
    // de l'aller-retour de connexion, le paramètre d'URL peut être abandonné
    // par Shopify, et le drapeau de session survit à tout tant que le visiteur
    // revient sur le site.
    const parAncre = window.location.hash === "#mise-en-avant";
    const parParam = new URLSearchParams(window.location.search).has("mise-en-avant");
    let parSession = false;
    try { parSession = sessionStorage.getItem("sdv_intention") === "mise-en-avant"; } catch (e) {}
    if (!parAncre && !parParam && !parSession) return;
    try { sessionStorage.removeItem("sdv_intention"); } catch (e) {}
    const cible = document.getElementById("mise-en-avant");
    if (!cible || cible.hidden) return;
    cible.scrollIntoView({ behavior: "smooth", block: "center" });
    cible.classList.add("is-highlighted");
    setTimeout(() => cible.classList.remove("is-highlighted"), 2400);
  }

  async function initBoostShop() {
    const box = sdvVendorDashboard.querySelector("[data-boost-shop]");
    // Charger les boosts du vendeur (boutique + produits) une seule fois
    let active = null;
    try {
      const d = await fetch(proxyBase + "/seller/boosts", { credentials: "same-origin" }).then((r) => r.json());
      active = d.shopBoost;
      _boostsByProduct = {};
      (d.productBoosts || []).forEach((b) => { _boostsByProduct[b.shopifyProductId] = b; });
      decorateProductBoosts();
    } catch (e) {}
    if (!box || !_boostCfg) return;
    const btn = box.querySelector("[data-boost-shop-btn]");
    const statusEl = box.querySelector("[data-boost-shop-status]");
    const perksEl = box.querySelector("[data-boost-shop-perks]");
    const priceEl = box.querySelector("[data-boost-shop-price]");
    const termsEl = box.querySelector("[data-boost-shop-terms]");
    const noteEl = box.querySelector("[data-boost-shop-note]");
    const days = Number(_boostCfg.sellerPeriodDays) || 30;
    box.hidden = false;
    rejoindreMiseEnAvant();

    if (active && active.statut === "ACTIVE") {
      if (btn) btn.hidden = true;
      if (statusEl) {
        statusEl.hidden = false;
        const end = active.currentPeriodEnd ? new Date(active.currentPeriodEnd).toLocaleDateString("fr-FR") : "";
        statusEl.textContent = SDV_T("boost.shopActive", "✓ Boutique mise en avant") + (end ? " " + SDV_T("common.until", "jusqu'au") + " " + end : "");
      }
      if (noteEl) {
        noteEl.hidden = false;
        noteEl.textContent = SDV_T("boost.shopActiveNote", "Achat unique : la mise en avant s'arrête à cette date, sans reconduction ni prélèvement automatique. Un rappel vous est envoyé 3 jours avant.");
      }
      return;
    }

    // Mise en avant indisponible : marketplace encore fermée aux acheteurs
    // (mode « vendeurs uniquement ») ou boosts coupés en back-office. On garde
    // l'encart visible pour expliquer, mais sans bouton d'achat.
    if (_boostCfg.actif === false) {
      if (btn) btn.hidden = true;
      if (noteEl) {
        noteEl.hidden = false;
        noteEl.textContent = _boostCfg.indisponibleRaison === "prelaunch"
          ? SDV_T("boost.prelaunch", "Disponible à l'ouverture de la marketplace aux acheteurs. Inutile de payer une mise en avant tant que la boutique n'est pas visible du public.")
          : SDV_T("boost.unavailable", "Les boosts ne sont pas disponibles pour le moment.");
      }
      return;
    }

    if (!btn) return;
    const prix = boostShopPrix();

    // Avantages détaillés AVANT l'achat.
    if (perksEl) {
      const perks = [
        SDV_T("boost.perk.featured", "Votre boutique affichée dans « Les vendeurs à suivre » sur la page marketplace"),
        SDV_T("boost.perk.badge", "Badge « Boutique en avant » sur votre carte et sur votre page publique"),
        SDV_T("boost.perk.rating", "Votre note et votre nombre d'avis mis en avant à côté de votre nom"),
        SDV_T("boost.perk.duration", "Visible pendant {days} jours à compter du paiement", { days: days }),
      ];
      perksEl.innerHTML = perks.map((p) => "<li>" + escapeHtml(p) + "</li>").join("");
      perksEl.hidden = false;
    }
    if (priceEl) {
      priceEl.hidden = false;
      priceEl.textContent = prix.detaille
        ? boostEuros(prix.ttc) + " " + SDV_T("boost.ttc", "TTC")
          + " (" + boostEuros(prix.ht) + " " + SDV_T("boost.ht", "HT") + " + " + boostEuros(prix.tva) + " " + SDV_T("boost.vat", "de TVA") + ")"
        : boostEuros(prix.ttc);
    }
    if (termsEl) {
      termsEl.hidden = false;
      termsEl.textContent = SDV_T("boost.oneShot", "Achat unique de {days} jours : aucun abonnement, aucun prélèvement automatique. À l'échéance, vous pouvez racheter la mise en avant si vous le souhaitez.", { days: days });
    }

    btn.hidden = false;
    btn.textContent = SDV_T("boost.shopCta", "Mettre ma boutique en avant") + " — " + boostEuros(prix.ttc)
      + (prix.detaille ? " " + SDV_T("boost.ttc", "TTC") : "");
    btn.addEventListener("click", async () => {
      btn.disabled = true; btn.textContent = SDV_T("common.redirecting", "Redirection…");
      try {
        const r = await fetch(proxyBase + "/seller/boost/shop", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: "{}" });
        const d = await r.json().catch(() => ({}));
        if (r.ok && d.invoiceUrl) { window.location.href = d.invoiceUrl; return; }
        alert(d.erreur || SDV_T("boost.payError", "Impossible de lancer le paiement."));
      } catch (e) { alert(SDV_T("common.networkError", "Erreur réseau.")); }
      btn.disabled = false; btn.textContent = SDV_T("common.retry", "Réessayer");
    }, { once: true });
  }

  function ouvrirBoostProduit(productId) {
    if (_boostCfg && _boostCfg.actif === false) {
      alert(_boostCfg.indisponibleRaison === "prelaunch"
        ? SDV_T("boost.prelaunch", "Disponible à l'ouverture de la marketplace aux acheteurs. Inutile de payer une mise en avant tant que la boutique n'est pas visible du public.")
        : SDV_T("boost.unavailable", "Les boosts ne sont pas disponibles pour le moment."));
      return;
    }
    if (!_boostCfg || !Array.isArray(_boostCfg.productTiers) || !_boostCfg.productTiers.length) {
      alert(SDV_T("boost.unavailable", "Les boosts ne sont pas disponibles pour le moment.")); return;
    }
    const overlay = document.createElement("div");
    overlay.className = "sdv-boost-overlay";
    const tiers = _boostCfg.productTiers.map((t) => {
      const detaille = t.priceTtcCents != null;
      const montant = boostEuros(detaille ? t.priceTtcCents : t.priceCents) + (detaille ? " " + SDV_T("boost.ttc", "TTC") : "");
      return `<button type="button" class="sdv-boost-overlay__opt" data-tier="${escapeHtml(t.key)}">${escapeHtml(t.label || t.key)} — ${montant}</button>`;
    }).join("");
    const tvaAffichee = _boostCfg.productTiers.some((t) => t.priceTtcCents != null);
    // Avantages listés avant le choix de la formule.
    const perks = [
      SDV_T("boost.perk.productRow", "Votre annonce dans la rangée « Produits mis en avant » de la marketplace"),
      SDV_T("boost.perk.productBadge", "Badge « ★ En avant » sur la photo de l'annonce"),
      SDV_T("boost.perk.productDuration", "Pendant toute la durée de la formule choisie"),
    ].map((p) => "<li>" + escapeHtml(p) + "</li>").join("");
    overlay.innerHTML = `<div class="sdv-boost-overlay__box"><h3>${SDV_T("boost.productTitle", "Booster cette annonce")}</h3><p>${SDV_T("boost.productDesc", "Apparaît en tête de la marketplace avec un badge « En avant ».")}</p><ul class="sdv-boost-overlay__perks">${perks}</ul>${tiers}<p class="sdv-boost-overlay__terms">${escapeHtml(tvaAffichee ? SDV_T("boost.oneShotProduct", "Achat unique, TVA 20 % incluse : aucun abonnement ni prélèvement automatique.") : SDV_T("boost.oneShotProductSimple", "Achat unique : aucun abonnement ni prélèvement automatique."))}</p><button type="button" class="sdv-boost-overlay__cancel">${SDV_T("common.cancel", "Annuler")}</button></div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener("click", async (e) => {
      if (e.target === overlay || e.target.classList.contains("sdv-boost-overlay__cancel")) { overlay.remove(); return; }
      const opt = e.target.closest("[data-tier]");
      if (!opt) return;
      opt.disabled = true; opt.textContent = SDV_T("common.redirecting", "Redirection…");
      try {
        const r = await fetch(proxyBase + "/seller/boost/product", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ shopifyProductId: productId, tierKey: opt.dataset.tier }) });
        const d = await r.json().catch(() => ({}));
        if (r.ok && d.invoiceUrl) { window.location.href = d.invoiceUrl; return; }
        if (r.ok && d.awaitingApproval) { alert(d.message || SDV_T("boost.awaitingApproval", "Boost enregistré : paiement proposé après validation de l'annonce.")); overlay.remove(); return; }
        alert(d.erreur || SDV_T("boost.payError", "Impossible de lancer le paiement."));
      } catch (e2) { alert(SDV_T("common.networkError", "Erreur réseau.")); }
      overlay.remove();
    });
  }

  productModal?.querySelectorAll("[data-sdv-modal-close]").forEach((el) => {
    el.addEventListener("click", closeProductModal);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && productModal && !productModal.hidden) closeProductModal();
  });

  productEditForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!editingProductId) return;
    const titleInput = productModal.querySelector("[data-edit-title]");
    const priceInput = productModal.querySelector("[data-edit-price]");
    const stockInput = productModal.querySelector("[data-edit-stock]");
    const statusNode = productModal.querySelector("[data-edit-status]");
    const saveBtn = productModal.querySelector("[data-edit-save]");

    const title = (titleInput?.value || "").trim();
    const price = parseFloat((priceInput?.value || "").replace(",", "."));
    const stockRaw = (stockInput?.value || "").trim();
    const stock = stockRaw === "" ? undefined : parseInt(stockRaw, 10);
    if (!title || isNaN(price) || price <= 0) {
      if (statusNode) statusNode.textContent = SDV_T("vp.edit.invalidTitlePrice", "Titre et prix valides requis.");
      return;
    }
    if (stock !== undefined && (isNaN(stock) || stock < 0)) {
      if (statusNode) statusNode.textContent = SDV_T("vp.edit.invalidStock", "Stock invalide.");
      return;
    }

    const payload = { title, price };
    if (stock !== undefined) payload.quantity = stock;

    if (statusNode) statusNode.textContent = "";
    if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = SDV_T("common.saving", "Enregistrement…"); }
    try {
      const result = await sendProductRequest("PUT", payload);
      closeProductModal();
      await loadVendorDashboard();
      if (result.stockErreur) console.warn("Stock non mis à jour:", result.stockErreur);
    } catch (error) {
      if (statusNode) statusNode.textContent = error.message || SDV_T("vp.edit.updateError", "Erreur lors de la mise à jour.");
    } finally {
      if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = SDV_T("common.save", "Enregistrer"); }
    }
  });

  // Étape 1 : révéler la confirmation
  productModal?.querySelector("[data-edit-delete]")?.addEventListener("click", () => {
    const confirmBox = productModal.querySelector("[data-edit-confirm]");
    const deleteBtn = productModal.querySelector("[data-edit-delete]");
    if (deleteBtn) deleteBtn.hidden = true;
    if (confirmBox) confirmBox.hidden = false;
  });

  // Étape 2a : annuler
  productModal?.querySelector("[data-edit-confirm-no]")?.addEventListener("click", () => {
    resetDeleteConfirm();
  });

  // Étape 2b : confirmer la suppression
  productModal?.querySelector("[data-edit-confirm-yes]")?.addEventListener("click", async () => {
    if (!editingProductId) return;
    const statusNode = productModal.querySelector("[data-edit-status]");
    const confirmYes = productModal.querySelector("[data-edit-confirm-yes]");
    const confirmNo = productModal.querySelector("[data-edit-confirm-no]");
    if (statusNode) statusNode.textContent = "";
    if (confirmYes) { confirmYes.disabled = true; confirmYes.textContent = SDV_T("common.deleting", "Suppression…"); }
    if (confirmNo) confirmNo.disabled = true;
    try {
      await sendProductRequest("DELETE");
      closeProductModal();
      await loadVendorDashboard();
    } catch (error) {
      if (statusNode) statusNode.textContent = error.message || SDV_T("vp.edit.deleteError", "Suppression impossible.");
    } finally {
      if (confirmYes) { confirmYes.disabled = false; confirmYes.textContent = SDV_T("vp.edit.confirmDelete", "Oui, supprimer"); }
      if (confirmNo) confirmNo.disabled = false;
    }
  });

  function renderSales(sales, opts) {
    const list = sdvVendorDashboard.querySelector(opts.listSel);
    const empty = opts.emptySel ? sdvVendorDashboard.querySelector(opts.emptySel) : null;
    const more = opts.moreSel ? sdvVendorDashboard.querySelector(opts.moreSel) : null;
    if (!list) return;

    const all = Array.isArray(sales) ? sales : [];
    const items = opts.limit ? all.slice(0, opts.limit) : all;

    if (items.length === 0) {
      list.hidden = true;
      list.innerHTML = "";
      if (empty) empty.hidden = false;
      if (more) more.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    list.hidden = false;
    if (more) more.hidden = !(opts.limit && all.length > opts.limit);

    list.innerHTML = items
      .map((sale) => {
        const title = escapeHtml(sale.productName || "Article");
        const qty = Number(sale.quantity) || 1;
        const qtyLabel = qty > 1 ? ` ×${qty}` : "";
        const net = Math.round(Number(sale.netCents || 0) / 100).toLocaleString("fr-FR");
        const dateLabel = sale.date
          ? new Date(sale.date).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })
          : "";
        const customer = escapeHtml(sale.customer || "");
        const img = escapeHtml(sale.imageUrl || "");
        return `
        <div class="order-row">
          <div class="order-row__thumb">
            ${
              img
                ? `<img src="${img}" alt="${title}" loading="lazy" width="64" height="64">`
                : `<div style="width:100%;height:100%;background:var(--pierre-100);"></div>`
            }
          </div>
          <div class="order-row__info">
            <p class="order-row__title">${title}${qtyLabel}</p>
            <p class="order-row__meta">${dateLabel}${customer ? ` · ${customer}` : ""}</p>
          </div>
          <div class="order-row__right">
            <span class="order-row__price">${net} € nets</span>
            <span class="status-pill status-pill--ok">Payé</span>
          </div>
        </div>`;
      })
      .join("");
  }

  function formatCents(cents) {
    return `${(Math.round(Number(cents || 0)) / 100).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} €`;
  }

  // Ventilation du virement vendeur (Modèle B, pass-through livraison) :
  // Articles + Port encaissé − Commission − Étiquette réelle = Net à recevoir.
  function payoutBreakdownHtml(order) {
    const port = Number(order.shippingChargedCents || 0);
    const label = Number(order.shippingLabelCents || 0);
    const row = (lbl, value, cls) =>
      `<div${cls ? ` class="${cls}"` : ""}><dt>${lbl}</dt><dd>${value}</dd></div>`;
    return `
      <div class="sdv-marketplace-order-card__payout">
        <p class="seller-section-eyebrow">Votre virement</p>
        <dl class="sdv-payout-breakdown">
          ${row("Articles", formatCents(order.totalAmount))}
          ${port > 0 ? row("+ Port encaissé", "+ " + formatCents(port)) : ""}
          ${row("- Commission Salon du Vintage", "- " + formatCents(order.commissionAmount))}
          ${label > 0 ? row("- Étiquette d'expédition", "- " + formatCents(label)) : ""}
          ${row("Net à recevoir", formatCents(order.netAmount), "is-total")}
        </dl>
        ${label === 0 && order.deliveryMethod !== "seller_pickup"
          ? `<p class="sdv-marketplace-order-card__meta" style="margin-top:6px;">L'étiquette d'expédition sera déduite à son achat (à l'acceptation de la commande).</p>`
          : ""}
      </div>`;
  }

  function renderPayoutHistory(payouts) {
    const list = sdvVendorDashboard.querySelector("[data-sdv-payout-history]");
    const empty = sdvVendorDashboard.querySelector("[data-sdv-payout-history-empty]");
    if (!list) return;
    const rows = Array.isArray(payouts) ? payouts : [];
    if (!rows.length) {
      list.hidden = true;
      list.innerHTML = "";
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    list.hidden = false;
    const statusLabel = (status) => ({
      paid: SDV_T("payout.status.paid", "Payé"),
      available: SDV_T("payout.status.available", "À virer"),
      blocked_pending_order: SDV_T("payout.status.blocked", "En attente de livraison"),
      cancelled: SDV_T("payout.status.cancelled", "Annulé"),
    }[status] || status);
    list.innerHTML = rows.map((payout) => {
      const date = payout.paidAt
        ? new Date(payout.paidAt).toLocaleDateString(document.documentElement.lang || "fr-FR")
        : "";
      const invoice = payout.invoiceNumber
        ? `<a href="${proxyBase}/seller/payout-invoice/${encodeURIComponent(payout.invoiceNumber)}" target="_blank" rel="noopener">${SDV_T("payout.invoice", "Facture de commission")} ${escapeHtml(payout.invoiceNumber)} ↗\uFE0E</a>`
        : "";
      return `<article class="sdv-payout-history__row">
        <div><strong>${escapeHtml(payout.orderName)}</strong><span>${statusLabel(payout.status)}${date ? ` · ${date}` : ""}</span>${invoice ? `<span>${invoice}</span>` : ""}</div>
        <strong>${formatCents(payout.netCents)}</strong>
      </article>`;
    }).join("");
  }

  function formatAddress(address) {
    if (!address) return "Adresse non renseignée";
    return [
      address.name,
      address.company,
      address.address1,
      address.address2,
      [address.zip, address.city].filter(Boolean).join(" "),
      address.province,
      address.country,
      address.phone ? `Tél. ${address.phone}` : "",
    ].filter(Boolean).map(escapeHtml).join("<br>");
  }

  function orderActionButtons(order) {
    const status = order.marketplaceStatus;
    if (status === "paid_pending_seller" || status === "seller_no_response") {
      return `
        <button type="button" class="is-primary" data-sdv-order-action="accept" data-order-id="${escapeHtml(order.id)}">Confirmer</button>
        <button type="button" data-sdv-order-action="reject" data-order-id="${escapeHtml(order.id)}">Refuser</button>`;
    }
    if (status === "accepted_by_seller") {
      const label = order.label || {};
      if (order.deliveryMethod === "seller_pickup" || label.status === "pickup") {
        return `
          <div class="sdv-label-panel sdv-label-panel--info">
            <p class="sdv-label-panel__msg">Retrait vendeur — aucune étiquette Sendcloud n'est créée. Préparez l'article puis indiquez qu'il est prêt.</p>
            <button type="button" class="is-primary" data-sdv-order-action="ship" data-order-id="${escapeHtml(order.id)}">Article prêt au retrait</button>
          </div>`;
      }
      const isQuote = label.status === "quote" || (order.items || []).some((it) => it.shipping_tier === "furniture");

      if (isQuote) {
        return `
          <div class="sdv-label-panel sdv-label-panel--info">
            <p class="sdv-label-panel__msg">📦 Livraison sur devis — organisez l'expédition (tarif déjà convenu avec l'acheteur), puis marquez la commande expédiée.</p>
            <button type="button" class="is-primary" data-sdv-order-action="ship" data-order-id="${escapeHtml(order.id)}">Marquer expédiée</button>
          </div>`;
      }

      if (label.status === "purchased" && label.labelReady) {
        return `
          <div class="sdv-label-panel sdv-label-panel--success">
            <p class="sdv-label-panel__msg">✓ Étiquette prête (prise en charge par Salon du Vintage)${label.trackingNumber ? ` · N° ${escapeHtml(label.trackingNumber)}` : ""}</p>
            <a href="${proxyBase}/seller/orders/${encodeURIComponent(order.id)}/label-file" target="_blank" rel="noopener" class="sdv-label-btn sdv-label-btn--download">⬇ Imprimer l'étiquette PDF</a>
            <button type="button" class="is-primary" data-sdv-order-action="ship" data-order-id="${escapeHtml(order.id)}">Marquer expédiée</button>
          </div>`;
      }

      // Aucune création automatique : le clic déclenche Sendcloud puis ouvre le PDF.
      return `
        <div class="sdv-label-panel" data-label-panel="${escapeHtml(order.id)}">
          <p class="sdv-label-panel__msg">Commande acceptée. Créez l'étiquette uniquement lorsque vous êtes prêt à l'imprimer.</p>
          ${label.erreur ? `<p class="sdv-label-panel__error">${escapeHtml(label.erreur)}</p>` : ""}
          <button type="button" class="sdv-label-btn sdv-label-btn--generate" data-sdv-generate-label="${escapeHtml(order.id)}">Imprimer l'étiquette</button>
        </div>`;
    }
    if (status === "shipped") {
      return order.deliveryMethod === "seller_pickup"
        ? `<span class="status-pill status-pill--transit">Prête au retrait — en attente de confirmation acheteur</span>`
        : `<span class="status-pill status-pill--transit">Expédiée — paiement libéré après livraison</span>`;
    }
    if (status === "completed") {
      return `<span class="status-pill status-pill--ok">Payout disponible</span>`;
    }
    if (status === "dispute_open") {
      return `<span class="status-pill status-pill--pending">SAV ouvert</span>`;
    }
    if (status === "rejected_by_seller") {
      return `<span class="status-pill status-pill--draft">Remboursement admin à traiter</span>`;
    }
    return `<span class="status-pill status-pill--draft">${escapeHtml(order.marketplaceStatusLabel || status || "Statut inconnu")}</span>`;
  }

  function renderMarketplaceOrders(orders, opts) {
    const list = sdvVendorDashboard.querySelector(opts.listSel);
    const empty = opts.emptySel ? sdvVendorDashboard.querySelector(opts.emptySel) : null;
    if (!list) return;
    const all = Array.isArray(orders) ? orders : [];
    const filtered = opts.confirmOnly
      ? all.filter((order) => ["paid_pending_seller", "seller_no_response", "accepted_by_seller"].includes(order.marketplaceStatus))
      : all;

    if (!filtered.length) {
      list.hidden = true;
      list.innerHTML = "";
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    list.hidden = false;
    list.innerHTML = filtered.map((order) => {
      const items = Array.isArray(order.items) ? order.items : [];
      const dateLabel = order.createdAt
        ? new Date(order.createdAt).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })
        : "";
      return `
        <article class="sdv-marketplace-order-card" data-marketplace-order-id="${escapeHtml(order.id)}">
          <div class="sdv-marketplace-order-card__head">
            <div>
              <p class="sdv-marketplace-order-card__title">${escapeHtml(order.shopifyOrderId)} · ${formatCents(order.netAmount)} nets</p>
              <p class="sdv-marketplace-order-card__meta">${dateLabel} · ${escapeHtml(order.marketplaceStatusLabel || "")} · payout ${escapeHtml(order.payoutStatusLabel || "")}</p>
            </div>
            <span class="status-pill ${order.marketplaceStatus === "completed" ? "status-pill--ok" : "status-pill--transit"}">${escapeHtml(order.marketplaceStatusLabel || "")}</span>
          </div>
          <div class="sdv-marketplace-order-card__grid">
            <div>
              <p class="seller-section-eyebrow">Articles</p>
              <ul class="sdv-marketplace-order-card__items">
                ${items.map((item) => `<li>${escapeHtml(item.product_name || "Article")} × ${Number(item.quantity) || 1}</li>`).join("")}
              </ul>
              ${(Array.isArray(order.invoices) ? order.invoices : []).map((inv) => `<p class="sdv-marketplace-order-card__meta" style="margin-top:6px;">📄 <a href="${proxyBase}/seller/invoice/${escapeHtml(inv.id)}" target="_blank" rel="noopener">${inv.isCreditNote ? SDV_T("order.doc.creditNote", "Avoir") : SDV_T("order.doc.invoice", "Facture")} ${escapeHtml(inv.number)} ↗\uFE0E</a></p>`).join("")}
            </div>
            <div>
              <p class="seller-section-eyebrow">Expédition acheteur</p>
              <p class="sdv-marketplace-order-card__address">${order.deliveryMethod === "seller_pickup" ? "Retrait auprès de votre boutique" : formatAddress(order.shippingAddress)}</p>
              ${order.deliveryMethod === "service_point" && order.servicePoint ? `<p class="sdv-marketplace-order-card__meta">Point relais : ${escapeHtml(order.servicePoint.name || "")} · ${escapeHtml(order.servicePoint.zip || "")} ${escapeHtml(order.servicePoint.city || "")}</p>` : ""}
              <p class="sdv-marketplace-order-card__meta" style="margin-top:8px;">
                ${order.customerEmail ? `<a href="mailto:${escapeHtml(order.customerEmail)}">${escapeHtml(order.customerEmail)}</a>` : ""}
                ${order.buyerPhone ? ` · <a href="tel:${escapeHtml(order.buyerPhone)}">${escapeHtml(order.buyerPhone)}</a>` : ""}
              </p>
            </div>
          </div>
          ${payoutBreakdownHtml(order)}
          <div class="sdv-marketplace-order-card__actions">${orderActionButtons(order)}</div>
        </article>`;
    }).join("");
  }

  async function sendSellerOrderAction(orderId, action, payload) {
    const response = await fetch(`${proxyBase}/seller/orders/${encodeURIComponent(orderId)}/${action}`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload || {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.erreur || SDV_T("common.actionError", "Action impossible."));
    return data;
  }

  // Charger le tarif étiquette pour chaque commande accepted_by_seller
  async function chargerTarifsEtiquettes() {
    const panels = sdvVendorDashboard.querySelectorAll("[data-label-panel]");
    panels.forEach(async (panel) => {
      const orderId = panel.dataset.labelPanel;
      if (!orderId) return;
      try {
        const res = await fetch(`${proxyBase}/seller/orders/${encodeURIComponent(orderId)}/label-rate`, { credentials: "same-origin" });
        const data = await res.json().catch(() => ({}));
        const loadingEl = sdvVendorDashboard.querySelector(`[data-label-rate-loading="${orderId}"]`);
        const readyEl = sdvVendorDashboard.querySelector(`[data-label-rate-ready="${orderId}"]`);
        const costEl = sdvVendorDashboard.querySelector(`[data-label-cost="${orderId}"]`);
        if (loadingEl) loadingEl.hidden = true;
        if (data.surDevis) {
          if (panel) panel.innerHTML = '<p class="sdv-label-panel__msg">📦 Livraison sur devis — organisez l\'expédition vous-même (tarif déjà convenu avec l\'acheteur), puis marquez la commande expédiée.</p>';
          return;
        }
        if (costEl && data.costCents) {
          const euros = (data.costCents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2 }) + " €";
          costEl.textContent = "Étiquette " + (data.carrierName || "") + " — " + euros;
        }
        if (readyEl) readyEl.hidden = false;
      } catch {
        const loadingEl = sdvVendorDashboard.querySelector(`[data-label-rate-loading="${orderId}"]`);
        if (loadingEl) loadingEl.textContent = SDV_T("vp.rateUnavailable", "Tarif indisponible");
      }
    });
  }

  // Prolongation d'une annonce
  sdvVendorDashboard.addEventListener("click", async (event) => {
    const renewBtn = event.target.closest("[data-renew-product]");
    if (!renewBtn) return;
    const productId = renewBtn.dataset.renewProduct;
    if (!productId) return;
    renewBtn.setAttribute("disabled", "disabled");
    renewBtn.textContent = SDV_T("vp.renew.loading", "Prolongation...");
    try {
      const res = await fetch(`${proxyBase}/seller/products/${encodeURIComponent(productId)}/renew`, {
        method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.erreur || SDV_T("vp.renew.error", "Prolongation impossible."));
      await loadVendorDashboard();
    } catch (err) {
      alert(err.message || SDV_T("vp.renew.error", "Prolongation impossible."));
      renewBtn.removeAttribute("disabled");
      renewBtn.textContent = SDV_T("vp.renew.cta", "Prolonger");
    }
  });

  // Retirer une annonce (vendue ailleurs)
  sdvVendorDashboard.addEventListener("click", async (event) => {
    const removeBtn = event.target.closest("[data-remove-product]");
    if (!removeBtn) return;
    const productId = removeBtn.dataset.removeProduct;
    if (!productId) return;
    if (!confirm(SDV_T("vp.remove.confirm", "Retirer cette annonce ? Elle sera définitivement supprimée de la vente (ex : article vendu ailleurs)."))) return;
    removeBtn.setAttribute("disabled", "disabled");
    removeBtn.textContent = SDV_T("vp.remove.loading", "Retrait...");
    try {
      const res = await fetch(`${proxyBase}/seller/products/${encodeURIComponent(productId)}/retirer`, {
        method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ raison: "vendu_ailleurs" }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.erreur || SDV_T("vp.remove.error", "Retrait impossible."));
      await loadVendorDashboard();
    } catch (err) {
      alert(err.message || SDV_T("vp.remove.error", "Retrait impossible."));
      removeBtn.removeAttribute("disabled");
      removeBtn.textContent = SDV_T("vp.remove", "Retirer (vendu ailleurs)");
    }
  });

  // Génération d'étiquette
  sdvVendorDashboard.addEventListener("click", async (event) => {
    const generateBtn = event.target.closest("[data-sdv-generate-label]");
    if (generateBtn) {
      const orderId = generateBtn.dataset.sdvGenerateLabel;
      if (!orderId) return;
      generateBtn.setAttribute("disabled", "disabled");
      generateBtn.textContent = SDV_T("vp.label.loading", "Création de l'étiquette...");
      try {
        const res = await fetch(`${proxyBase}/seller/orders/${encodeURIComponent(orderId)}/label`, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.erreur || SDV_T("vp.label.error", "Étiquette indisponible."));
        if (data.labelReady) window.open(`${proxyBase}/seller/orders/${encodeURIComponent(orderId)}/label-file`, "_blank", "noopener");
        await loadVendorDashboard();
      } catch (err) {
        alert(err.message || SDV_T("vp.label.retry", "Étiquette indisponible pour le moment, réessayez."));
        generateBtn.removeAttribute("disabled");
        generateBtn.textContent = SDV_T("vp.label.print", "Imprimer l'étiquette");
      }
      return;
    }
  });

  sdvVendorDashboard.addEventListener("click", async (event) => {
    const btn = event.target.closest("[data-sdv-order-action]");
    if (!btn) return;
    const card = btn.closest("[data-marketplace-order-id]");
    const orderId = btn.dataset.orderId || card?.dataset.marketplaceOrderId;
    const action = btn.dataset.sdvOrderAction;
    if (!orderId || !action) return;
    const payload = {};
    if (action === "reject") {
      const message = window.prompt("Pourquoi refusez-vous cette commande ?") || "";
      payload.message = message;
    }
    if (action === "ship") {
      payload.trackingCarrier = card?.querySelector("[data-tracking-carrier]")?.value || "";
      payload.trackingNumber = card?.querySelector("[data-tracking-number]")?.value || "";
    }
    btn.setAttribute("disabled", "disabled");
    try {
      await sendSellerOrderAction(orderId, action, payload);
      await loadVendorDashboard();
    } catch (error) {
      alert(error.message || SDV_T("common.actionError", "Action impossible."));
    } finally {
      btn.removeAttribute("disabled");
    }
  });

  async function loadVendorDashboard() {
    try {
      const response = await fetch(`${proxyBase}/seller/summary`, { credentials: "same-origin" });
      const data = await response.json();

      // Aucune boutique liée (compte existant jamais vendeur) → formulaire d'activation.
      if (!response.ok) {
        if (response.status === 404 && !sdvVendorDashboard.dataset.onboardRedirected) {
          sdvVendorDashboard.dataset.onboardRedirected = "1";
          window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "pages/inscription-vendeur";
          return;
        }
        throw new Error(data.erreur || "Chargement impossible");
      }

      // Boutique en attente d'activation (email non encore vérifié à l'inscription).
      // Ici l'utilisateur est connecté (⇒ email vérifié) : on tente d'activer une fois, puis on recharge.
      if (data.seller && !data.seller.active) {
        if (!sdvVendorDashboard.dataset.activateAttempted) {
          sdvVendorDashboard.dataset.activateAttempted = "1";
          const onboardResp = await fetch(`${proxyBase}/seller/onboard`, {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: sdvVendorDashboard.dataset.customerEmail || "" }),
          }).catch(() => null);
          if (onboardResp?.ok) {
            const d = await onboardResp.json().catch(() => ({}));
            if (d.sellerStatus === "ACTIVE") { await loadVendorDashboard(); return; }
          }
        }
        // Toujours pas active → bandeau persistant « vérifiez votre email »
        const panelInner = sdvVendorDashboard.querySelector("[data-vendor-panel='overview'] .seller-panel-inner");
        if (panelInner && !panelInner.querySelector("[data-pending-banner]")) {
          const banner = document.createElement("div");
          banner.className = "seller-alert";
          banner.setAttribute("role", "status");
          banner.setAttribute("data-pending-banner", "");
          banner.innerHTML = "<p><strong>Boutique en attente d'activation.</strong> Vérifiez votre email pour activer votre boutique et publier vos articles. <button type='button' data-pending-recheck style='text-decoration:underline;background:none;border:0;cursor:pointer;font:inherit;color:inherit;'>J'ai vérifié — réessayer</button></p>";
          panelInner.prepend(banner);
          banner.querySelector("[data-pending-recheck]")?.addEventListener("click", () => {
            sdvVendorDashboard.dataset.activateAttempted = "";
            loadVendorDashboard();
          });
        }
      }

      setVendorText("[data-sdv-seller-name]", data.seller?.name);
      const publicLink = sdvVendorDashboard.querySelector("[data-sdv-seller-public-link]");
      if (publicLink && (data.seller?.publicPath || data.seller?.handle)) {
        publicLink.href = SDV_LOCALIZE_URL(data.seller?.publicPath || `/pages/vendeurs/${encodeURIComponent(data.seller.handle)}`);
        publicLink.removeAttribute("aria-disabled");
      }
      const previewLink = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-link]");
      if (previewLink && (data.seller?.publicPath || data.seller?.handle)) {
        previewLink.href = SDV_LOCALIZE_URL(data.seller?.publicPath || `/pages/vendeurs/${encodeURIComponent(data.seller.handle)}`);
      }

      if (profileForm) {
        const fields = publicProfileFields(data);
        setProfileInput("name", fields.name || data.seller?.name || "");
        setProfileInput("badge", fields.badge || "Vendeur particulier");
        setProfileInput("bio", fields.bio || "");
        // location = "Ville, Pays" → on resplit pour les deux champs
        {
          const loc = (fields.location || data.seller?.city || "").trim();
          const idx = loc.lastIndexOf(",");
          const cityPart = idx !== -1 ? loc.slice(0, idx).trim() : loc;
          const countryPart = idx !== -1 ? loc.slice(idx + 1).trim() : "";
          setProfileInput("city", cityPart);
          // Le pays d'expédition vient de la fiche vendeur, pas du libellé
          // « Ville, Pays » du profil public : c'est lui qui sert d'adresse
          // d'expéditeur pour la cotation et l'étiquette.
          setProfileInput("shippingCountry", data.seller?.shippingCountry || "FR");
          void countryPart;
        }
        setProfileInput("instagram", fields.instagram || "");
        setProfileInput("website", fields.website || "");
        setProfileInput("avatarUrl", fields.avatar_url || "");
        // Avatar de l'en-tête du dashboard (même source que l'aperçu public)
        const headerAvatar = sdvVendorDashboard.querySelector("[data-sdv-seller-avatar]");
        if (headerAvatar && fields.avatar_url) {
          headerAvatar.innerHTML = `<img src="${escapeHtml(fields.avatar_url)}" alt="${escapeHtml(fields.name || data.seller?.name || "")}" width="44" height="44">`;
        }
        setProfileInput("specialties", fields.specialties || "Mode vintage,Objets rares");
        setProfileInput("profileTitle", fields.profile_title || "");
        setProfileInput("profileIntro", fields.profile_intro || "");
        if (payoutDisplay && fields.payout_iban_masked) {
          payoutDisplay.textContent = fields.payout_iban_masked;
        }
        if (payoutState && fields.payout_status) {
          payoutState.textContent = fields.payout_status;
        }
        renderSpecialties();
        renderProfilePreview();
      }

      const stats = data.stats || {};
      const fmtEuros = (cents) =>
        `${Math.round(Number(cents || 0) / 100).toLocaleString("fr-FR")} €`;
      const productCount =
        stats.activeProducts ?? (Array.isArray(data.products) ? data.products.length : 0);
      setVendorText("[data-sdv-stat='products']", productCount);
      setVendorText("[data-sdv-stat='sales']", stats.salesMonth ?? 0);
      setVendorText(
        "[data-sdv-stat='revenue']",
        stats.netMonthCents != null ? fmtEuros(stats.netMonthCents) : "— €"
      );
      // Note vendeur : laissée au rendu serveur (metafield), pas de placeholder

      // Résumé financier (onglet Revenus & paiements) — montants réels
      const finGrossLabel = sdvVendorDashboard.querySelector("[data-sdv-fin-gross-label]");
      if (finGrossLabel && stats.salesMonth != null) {
        const n = stats.salesMonth;
        finGrossLabel.textContent = `Ventes brutes ce mois (${n} article${n > 1 ? "s" : ""})`;
      }
      setVendorText(
        "[data-sdv-fin-gross]",
        stats.grossMonthCents != null ? fmtEuros(stats.grossMonthCents) : "— €"
      );
      setVendorText(
        "[data-sdv-fin-commission]",
        stats.commissionMonthCents != null ? `− ${fmtEuros(stats.commissionMonthCents)}` : "— €"
      );
      setVendorText(
        "[data-sdv-fin-net]",
        stats.netMonthCents != null ? fmtEuros(stats.netMonthCents) : "— €"
      );

      renderProducts(data.products || []);
      renderMarketplaceOrders(data.orders || [], {
        listSel: "[data-sdv-orders-to-confirm]",
        emptySel: "[data-sdv-orders-to-confirm-empty]",
        confirmOnly: true,
      });
      renderPayoutHistory(data.payouts || []);
      renderMarketplaceOrders(data.orders || [], {
        listSel: "[data-sdv-all-sales]",
        emptySel: "[data-sdv-all-sales-empty]",
      });
      renderSales(data.sales || [], {
        listSel: "[data-sdv-recent-sales]",
        emptySel: "[data-sdv-recent-sales-empty]",
        moreSel: "[data-sdv-recent-sales-more]",
        limit: 5,
      });
      sdvVendorDashboard.classList.remove("is-loading");
    } catch (error) {
      sdvVendorDashboard.classList.remove("is-loading");
      const empty = sdvVendorDashboard.querySelector("[data-sdv-products-empty]");
      if (empty) empty.textContent = SDV_T("vp.soon", "Vos produits seront bientôt disponibles ici.");
    }
  }

  profileForm?.addEventListener("input", renderProfilePreview);
  specialtyOptions.forEach((button) => {
    button.addEventListener("click", () => {
      const value = button.dataset.sdvSpecialtyOption || "";
      const selected = selectedSpecialties();
      const exists = selected.includes(value);
      const next = exists ? selected.filter((tag) => tag !== value) : selected.concat(value).slice(0, 3);
      if (specialtyInput) specialtyInput.value = next.join(",");
      renderSpecialties();
      renderProfilePreview();
    });
  });

  avatarInput?.addEventListener("change", async () => {
    const file = avatarInput.files?.[0];
    if (!file || !profileForm) return;
    if (!file.type.startsWith("image/")) {
      setAvatarStatus(SDV_T("profile.avatar.notImage", "Le fichier doit être une image."), "error");
      return;
    }
    if (file.size > 5_000_000) {
      setAvatarStatus(SDV_T("profile.avatar.tooBig", "Image trop lourde. Utilisez une image de moins de 5 Mo."), "error");
      return;
    }

    setAvatarStatus(SDV_T("profile.avatar.importing", "Import de la photo…"), "");
    avatarInput.setAttribute("disabled", "disabled");
    try {
      const imageAttachment = await dashboardFileToBase64(file);
      const response = await fetch(`${proxyBase}/seller/profile/avatar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ imageAttachment }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.erreur || SDV_T("profile.avatar.uploadError", "Upload impossible."));
      setProfileInput("avatarUrl", data.url || "");
      renderProfilePreview();
      setAvatarStatus(SDV_T("profile.avatar.imported", "Photo importée. Enregistrez pour publier."), "success");
    } catch (error) {
      setAvatarStatus(error.message || SDV_T("profile.avatar.importError", "Erreur pendant l'import de la photo."), "error");
    } finally {
      avatarInput.removeAttribute("disabled");
      avatarInput.value = "";
    }
  });

  profileForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    setProfileStatus(SDV_T("profile.saving", "Enregistrement de la page publique..."), "");
    const submit = profileForm.querySelector("button[type='submit']");
    submit?.setAttribute("disabled", "disabled");

    try {
      const payload = Object.fromEntries(new FormData(profileForm).entries());
      const response = await fetch(`${proxyBase}/seller/profile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.erreur || SDV_T("profile.updateError", "Mise à jour impossible."));

      const publicPath = data.path || profileForm.dataset.publicLink;
      const publicLink = sdvVendorDashboard.querySelector("[data-sdv-seller-public-link]");
      const previewLink = sdvVendorDashboard.querySelector("[data-sdv-profile-preview-link]");
      if (publicPath) {
        if (publicLink) publicLink.href = publicPath;
        if (previewLink) previewLink.href = publicPath;
      }
      setProfileStatus(SDV_T("profile.updated", "Page publique mise à jour."), "success");
    } catch (error) {
      setProfileStatus(error.message || SDV_T("profile.saveError", "Erreur pendant l'enregistrement."), "error");
    } finally {
      submit?.removeAttribute("disabled");
    }
  });

  payoutForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    setPayoutStatus(SDV_T("payout.saving", "Enregistrement des coordonnées de paiement..."), "");
    const submit = payoutForm.querySelector("button[type='submit']");
    submit?.setAttribute("disabled", "disabled");

    try {
      const payload = Object.fromEntries(new FormData(payoutForm).entries());
      const response = await fetch(`${proxyBase}/seller/payout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.erreur || SDV_T("payout.saveError", "Enregistrement impossible."));

      if (payoutDisplay) payoutDisplay.textContent = data.ibanMasked || "IBAN enregistré";
      if (payoutState) payoutState.textContent = "À vérifier";
      const ibanInput = payoutForm.querySelector("[name='iban']");
      if (ibanInput) ibanInput.value = "";
      setPayoutStatus(data.message || SDV_T("payout.saved", "Coordonnées enregistrées pour validation."), "success");
    } catch (error) {
      setPayoutStatus(error.message || SDV_T("profile.saveError", "Erreur pendant l'enregistrement."), "error");
    } finally {
      submit?.removeAttribute("disabled");
    }
  });

  loadVendorDashboard();
}

// ─────────────────────────────────────────────────────────────
// Espace client : commandes marketplace + confirmation / SAV
// ─────────────────────────────────────────────────────────────
const sdvCustomerMarketplaceOrders = document.querySelector("[data-sdv-customer-marketplace-orders]");

if (sdvCustomerMarketplaceOrders) {
  const proxyBase = (sdvCustomerMarketplaceOrders.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const supportEmail = sdvCustomerMarketplaceOrders.dataset.supportEmail || "";
  const list = sdvCustomerMarketplaceOrders.querySelector("[data-sdv-customer-marketplace-list]");
  const empty = sdvCustomerMarketplaceOrders.querySelector("[data-sdv-customer-marketplace-empty]");

  function escapeCustomerHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatCustomerCents(cents) {
    return `${(Math.round(Number(cents || 0)) / 100).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} €`;
  }

  function customerTrackingUrl(carrier, number) {
    const c = String(carrier || "").toLowerCase();
    const n = encodeURIComponent(String(number || "").trim());
    if (!n) return "";
    if (c.includes("colissimo")) return `https://www.laposte.fr/outils/suivre-vos-envois?code=${n}`;
    if (c.includes("mondial")) return `https://www.mondialrelay.fr/suivi-de-colis/?numeroExpedition=${n}`;
    if (c.includes("chrono")) return `https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=${n}`;
    return `https://parcelsapp.com/fr/tracking/${n}`;
  }

  function customerOrderActions(order) {
    const statusClass = order.marketplaceStatus === "completed" ? "status-pill--ok" : "status-pill--transit";
    const contact = supportEmail
      ? `<a class="sdv-order-support-link" href="mailto:${escapeCustomerHtml(supportEmail)}?subject=${encodeURIComponent("Question commande " + (order.shopifyOrderId || ""))}">Nous contacter par e-mail</a>`
      : "";
    return `<span class="status-pill ${statusClass}">${escapeCustomerHtml(order.marketplaceStatusLabel || "En cours")}</span>${contact}`;
  }

  function renderCustomerOrders(orders) {
    const all = Array.isArray(orders) ? orders : [];
    if (!list) return;
    if (!all.length) {
      list.hidden = true;
      list.innerHTML = "";
      if (empty) empty.textContent = SDV_T("order.empty", "Aucun achat marketplace pour le moment.");
      return;
    }
    if (empty) empty.hidden = true;
    list.hidden = false;
    list.innerHTML = all.map((order) => {
      const items = Array.isArray(order.items) ? order.items : [];
      const dateLabel = order.createdAt
        ? new Date(order.createdAt).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })
        : "";
      return `
        <article class="sdv-customer-order-card" data-customer-marketplace-order="${escapeCustomerHtml(order.id)}">
          <div>
            <p class="sdv-customer-order-card__title">${escapeCustomerHtml(order.shopifyOrderId)} · ${formatCustomerCents(order.totalAmount)}</p>
            <p class="sdv-customer-order-card__meta">${dateLabel} · ${escapeCustomerHtml(order.marketplaceStatusLabel || "")}</p>
            <ul class="sdv-customer-order-card__items">
              ${items.map((item) => `<li>${escapeCustomerHtml(item.product_name || "Article")} × ${Number(item.quantity) || 1}</li>`).join("")}
            </ul>
            ${order.deliveryMethod === "seller_pickup" ? `<p class="sdv-customer-order-card__meta" style="margin-top:8px;">${SDV_T("order.pickup", "Retrait auprès du vendeur")}</p>` : ""}
            ${order.deliveryMethod === "service_point" && order.servicePoint ? `<p class="sdv-customer-order-card__meta" style="margin-top:8px;">${SDV_T("order.servicePoint", "Point relais")} : ${escapeCustomerHtml(order.servicePoint.name || "")} · ${escapeCustomerHtml(order.servicePoint.zip || "")} ${escapeCustomerHtml(order.servicePoint.city || "")}</p>` : ""}
            ${order.trackingNumber ? `<p class="sdv-customer-order-card__meta" style="margin-top:8px;">${SDV_T("order.tracking", "Suivi")} : <a href="${escapeCustomerHtml(customerTrackingUrl(order.trackingCarrier, order.trackingNumber))}" target="_blank" rel="noopener">${escapeCustomerHtml(order.trackingCarrier || "")} ${escapeCustomerHtml(order.trackingNumber)} ↗\uFE0E</a></p>` : ""}
            ${(Array.isArray(order.invoices) ? order.invoices : []).map((inv) => `<p class="sdv-customer-order-card__meta" style="margin-top:8px;">📄 <a href="${proxyBase}/customer/invoice/${escapeCustomerHtml(inv.id)}" target="_blank" rel="noopener">${SDV_T("order.invoice.download", "Télécharger {doc}", { doc: inv.isJustificatif ? SDV_T("order.invoice.doc.receipt", "le justificatif") : SDV_T("order.invoice.doc.invoice", "la facture") })} ${escapeCustomerHtml(inv.number)} ↗\uFE0E</a></p>`).join("")}
          </div>
          <div class="sdv-customer-order-card__actions">${customerOrderActions(order)}</div>
        </article>`;
    }).join("");
  }

  async function loadCustomerOrders() {
    try {
      const res = await fetch(`${proxyBase}/customer/marketplace-orders`, { credentials: "same-origin" });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.erreur || "Chargement impossible.");
      renderCustomerOrders(data.orders || []);
    } catch (error) {
      if (empty) empty.textContent = error.message || SDV_T("order.loadError", "Impossible de charger les achats marketplace.");
    }
  }

  loadCustomerOrders();
}

// ─────────────────────────────────────────────────────────────
// Ajouter produit vendeur : tunnel Shopify → App Proxy → API SDV
// ─────────────────────────────────────────────────────────────
const sdvListingForm = document.querySelector("[data-sdv-listing-form]");

if (sdvListingForm) {
  const proxyBase = (sdvListingForm.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const backUrl = sdvListingForm.dataset.backUrl || "/pages/espace-vendeur";
  const intro = sdvListingForm.querySelector("[data-listing-intro]");
  const shell = sdvListingForm.querySelector("[data-listing-shell]");
  const startButton = sdvListingForm.querySelector("[data-listing-start]");
  const backIntroButton = sdvListingForm.querySelector("[data-listing-back-intro]");
  const categoryValue = sdvListingForm.querySelector("[data-listing-category-value]");
  const categoryHandle = sdvListingForm.querySelector("[data-listing-category-handle]");
  const subcategoryValue = sdvListingForm.querySelector("[data-listing-subcategory-value]");
  const subcatWrap = sdvListingForm.querySelector("[data-subcat-wrap]");
  const subcatSelect = sdvListingForm.querySelector("[data-subcat-select]");
  const sidebarTitle = sdvListingForm.querySelector("[data-sidebar-title]");
  const sidebarCategory = sdvListingForm.querySelector("[data-sidebar-category]");
  const titleInput = sdvListingForm.querySelector("[data-title-input]");
  const priceInput = sdvListingForm.querySelector("[data-price-input]");
  const photoInput = sdvListingForm.querySelector("[data-photo-input]");
  const statusNode = sdvListingForm.querySelector("[data-listing-status]");
  const submitForm = sdvListingForm.querySelector("[data-listing-submit]");
  let currentStep = 1;
  let maxVisitedStep = 1;
  let selectedCategoryLabel = "";
  let selectedImageAttachment = "";

  const subcats = {
    mode: ["Vêtements femme", "Vêtements homme", "Chaussures", "Accessoires", "Bijoux", "Sacs & Maroquinerie"],
    mobilier: ["Luminaires", "Assises", "Tables & Bureaux", "Rangements", "Déco & Objets", "Arts de la table"],
    vinyles: ["Vinyles 33 tours", "Vinyles 45 tours", "BD & Livres", "Affiches & Posters", "Jouets & Jeux", "Appareils audio"],
    luxe: ["Maroquinerie", "Horlogerie", "Joaillerie & Bijoux", "Mode luxe", "Arts de la table luxe"],
    auto: ["Pièces & Accessoires auto", "Pièces & Accessoires moto", "Accessoires & Équipement", "Vêtements auto/moto", "Objets & Signalétique", "Modèles réduits"],
  };

  // Tier par défaut selon catégorie
  const DEFAULT_TIER = {
    "mode-vintage": "small",
    "mobilier-design": "large",
    "vinyles-culture": "small",
    "luxe-vintage": "small",
    "auto-moto-vintage": "small",
  };

  function setStatus(message, type) {
    if (!statusNode) return;
    statusNode.textContent = message || "";
    statusNode.classList.toggle("is-error", type === "error");
    statusNode.classList.toggle("is-success", type === "success");
  }

  function slugify(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function filterTag(prefix, value) {
    const slug = slugify(value);
    return slug ? `${prefix}:${slug}` : "";
  }

  function formatEuros(value) {
    return value.toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " €";
  }

  function updateIntroState() {
    const category = sdvListingForm.querySelector("input[name='listing_category']:checked");
    const ok = Boolean(category && subcatSelect?.value);
    startButton?.toggleAttribute("disabled", !ok);
  }

  // ── Mise à jour du formulaire selon la catégorie choisie ──────────────────
  function updateFormForCategory(cat) {
    // 1. show/hide conditional rows
    sdvListingForm.querySelectorAll("[data-show-for]").forEach(function (row) {
      const cats = row.dataset.showFor.split(" ");
      row.style.display = cats.includes(cat) ? "" : "none";
      // désactive required sur les inputs cachés
      row.querySelectorAll("input, select, textarea").forEach(function (el) {
        if (!cats.includes(cat)) el.removeAttribute("required");
      });
    });

    // 2. labels et placeholders dynamiques
    sdvListingForm.querySelectorAll("[data-field-label]").forEach(function (lbl) {
      const key = "label" + cat.replace(/-/g, function(_, c) { return c; });
      const catKey = "label" + cat.split("-").map(function(p,i){ return i===0?p:p[0].toUpperCase()+p.slice(1); }).join("");
      const override = lbl.dataset["label" + cat.replace(/-([a-z])/g, function(_, c){ return c.toUpperCase(); })]
                    || lbl.dataset[catKey]
                    || lbl.dataset.labelDefault;
      if (override) {
        // keep the (facultatif) span if present
        const optional = lbl.querySelector("span");
        lbl.textContent = override + " ";
        if (optional) lbl.appendChild(optional);
      }
      // placeholder on sibling input
      const input = lbl.closest(".contact-form__row")?.querySelector("input");
      if (input) {
        const ph = input.dataset["placeholder" + cat.replace(/-([a-z])/g, function(_, c){ return c.toUpperCase(); })]
                || input.dataset.placeholderDefault;
        if (ph) input.placeholder = ph;
      }
    });

    // 3. pré-sélectionner le tier livraison
    const defaultTier = DEFAULT_TIER[cat] || "small";
    const tierRadio = sdvListingForm.querySelector("input[name='shippingTier'][value='" + defaultTier + "']");
    if (tierRadio) { tierRadio.checked = true; updateTierMode(); }

    // 4. mettre à jour le label commission dans le récap
    const commissionLabel = sdvListingForm.querySelector("[data-calc-commission-label]");
    if (commissionLabel) {
      commissionLabel.textContent = "Commission Salon du Vintage (" + (currentCategoryBps() / 100).toFixed(0) + " %)";
    }
    updatePriceCalc();
  }

  function goToStep(step) {
    currentStep = step;
    maxVisitedStep = Math.max(maxVisitedStep, step);
    sdvListingForm.querySelectorAll("[data-step-panel]").forEach((panel) => {
      panel.classList.toggle("is-active", panel.dataset.stepPanel === String(step));
    });
    sdvListingForm.querySelectorAll("[data-step-nav]").forEach((nav) => {
      const navStep = Number(nav.dataset.stepNav || 0);
      nav.classList.toggle("is-active", navStep === step);
      nav.classList.toggle("is-done", navStep < step);
      nav.toggleAttribute("data-nav-reachable", navStep <= maxVisitedStep);
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
    saveDraft();
  }

  // ── Préparation des photos avant envoi ────────────────────────────────────
  // Vercel refuse toute requête au-delà de 4,5 Mo, AVANT que le code s'exécute
  // (FUNCTION_PAYLOAD_TOO_LARGE). Comme une image est transmise en base64, qui
  // l'alourdit d'un tiers, une photo de plus de ~3,3 Mo échouait sans message
  // utile — c'est ce que rencontraient les vendeurs avec des photos de
  // téléphone. On redimensionne donc dans le navigateur : une photo de 8 Mo
  // tombe à quelques centaines de Ko, et le dépôt devient aussi beaucoup plus
  // rapide.
  const PHOTO_COTE_MAX_PX = 1600;
  const PHOTO_QUALITE = 0.82;
  const PHOTO_CHARGE_MAX = 3500000; // marge sous la limite de la plateforme

  /** Redimensionne et recompresse une image ; repli sur le fichier brut si impossible. */
  function preparerImage(file) {
    return new Promise(function (resolve, reject) {
      // Formats que le navigateur ne sait pas forcément décoder (HEIC…) :
      // on tente quand même, le repli ci-dessous prend le relais.
      const url = URL.createObjectURL(file);
      const img = new Image();

      function repli() {
        URL.revokeObjectURL(url);
        fileToBase64(file).then(function (brut) {
          if (brut.length > PHOTO_CHARGE_MAX) {
            reject(new Error(SDV_T(
              "listing.imageTooLarge",
              "Cette photo est trop lourde. Réduisez-la (environ 2 Mo maximum) puis réessayez."
            )));
            return;
          }
          resolve(brut);
        }, reject);
      }

      img.onload = function () {
        try {
          const cote = Math.max(img.naturalWidth, img.naturalHeight);
          const ratio = cote > PHOTO_COTE_MAX_PX ? PHOTO_COTE_MAX_PX / cote : 1;
          const largeur = Math.max(1, Math.round(img.naturalWidth * ratio));
          const hauteur = Math.max(1, Math.round(img.naturalHeight * ratio));
          const canvas = document.createElement("canvas");
          canvas.width = largeur;
          canvas.height = hauteur;
          const ctx = canvas.getContext("2d");
          if (!ctx) return repli();
          // Fond blanc : un PNG transparent converti en JPEG deviendrait noir.
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, largeur, hauteur);
          ctx.drawImage(img, 0, 0, largeur, hauteur);
          const dataUrl = canvas.toDataURL("image/jpeg", PHOTO_QUALITE);
          URL.revokeObjectURL(url);
          if (!dataUrl || dataUrl.length < 100) return repli();
          resolve(dataUrl);
        } catch (e) {
          repli();
        }
      };
      img.onerror = repli;
      img.src = url;
    });
  }

  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const value = String(reader.result || "");
        resolve(value);
      };
      reader.onerror = () => reject(new Error(SDV_T("common.imageReadError", "Lecture image impossible.")));
      reader.readAsDataURL(file);
    });
  }

  // Taux et montants par défaut, remplacés par la config serveur. Ne jamais
  // écrire ces valeurs en dur dans le gabarit : le vendeur lirait un chiffre
  // qui ne correspond plus aux réglages de l'admin.
  let _commissionBps = 1500;
  let _fraisTraitementBps = 300;
  let _expertConsultationActif = true;
  let _expertMontantCents = 9000;
  let _expertSeuilCents = 100000;
  let _payoutDelaiHeures = 72;

  // Charger la config depuis le proxy (taux, service expert)
  fetch(proxyBase + "/config", { credentials: "same-origin" })
    .then(function (r) { return r.ok ? r.json() : {}; })
    .then(function (cfg) {
      if (cfg && cfg.commissionBps) _commissionBps = Number(cfg.commissionBps);
      if (cfg && cfg.fraisTraitementBps) _fraisTraitementBps = Number(cfg.fraisTraitementBps);
      if (cfg && typeof cfg.expertConsultationActif === "boolean") _expertConsultationActif = cfg.expertConsultationActif;
      if (cfg && cfg.expertConsultationMontantCents) _expertMontantCents = Number(cfg.expertConsultationMontantCents);
      if (cfg && cfg.expertConsultationSeuilCents) _expertSeuilCents = Number(cfg.expertConsultationSeuilCents);
      if (cfg && cfg.payoutReleaseDelayHours) _payoutDelaiHeures = Number(cfg.payoutReleaseDelayHours);
      // Mettre à jour le label commission avec le taux réel
      const commissionLabel = sdvListingForm.querySelector("[data-calc-commission-label]");
      if (commissionLabel) {
        commissionLabel.textContent = "Commission Salon du Vintage (" + (currentCategoryBps() / 100).toFixed(0) + " %)";
      }
      const fraisLabel = sdvListingForm.querySelector("[data-calc-frais-label]");
      if (fraisLabel) {
        fraisLabel.textContent = "Frais de traitement (" + (_fraisTraitementBps / 100).toFixed(0) + " %)";
      }
      const payoutInfo = sdvListingForm.querySelector("[data-calc-payout-info]");
      if (payoutInfo) {
        var delaiTexte = _payoutDelaiHeures % 24 === 0
          ? (_payoutDelaiHeures / 24) + (_payoutDelaiHeures === 24 ? " jour" : " jours")
          : _payoutDelaiHeures + " heures";
        payoutInfo.textContent = "Le paiement est versé " + delaiTexte +
          " après la confirmation de livraison, sur votre compte bancaire renseigné dans l'espace vendeur.";
      }
      updateExpertPanel();
      // Encart boost produit
      if (cfg && cfg.boost && cfg.boost.actif && Array.isArray(cfg.boost.productTiers) && cfg.boost.productTiers.length) {
        const panel = sdvListingForm.querySelector("[data-boost-panel]");
        const opts = sdvListingForm.querySelector("[data-boost-options]");
        if (panel && opts) {
          opts.innerHTML =
            '<label class="sdv-boost-opt"><input type="radio" name="boostTier" value=""> <span>Aucun boost</span></label>' +
            cfg.boost.productTiers.map(function (t) {
              const price = (Number(t.priceCents) / 100).toFixed(2).replace(".", ",") + " €";
              return '<label class="sdv-boost-opt"><input type="radio" name="boostTier" value="' + t.key + '"> <span>' + (t.label || t.key) + " — " + price + "</span></label>";
            }).join("");
          const none = opts.querySelector('input[value=""]');
          if (none) none.checked = true;
          panel.hidden = false;
        }
      }
    })
    .catch(function () {});

  function currentCategoryBps() {
    // Taux de commission GLOBAL unique (plus de taux par catégorie).
    return _commissionBps;
  }

  function updatePriceCalc() {
    const price = Number(priceInput?.value || 0);
    const expertChecked = document.getElementById("sdv-expert-checkbox")?.checked || false;

    const calcPrice = sdvListingForm.querySelector("[data-calc-price]");
    const calcCommission = sdvListingForm.querySelector("[data-calc-commission]");
    const calcFrais = sdvListingForm.querySelector("[data-calc-frais]");
    const calcExpert = sdvListingForm.querySelector("[data-calc-expert]");
    const calcExpertRow = document.getElementById("sdv-calc-expert-row");
    const calcReceived = sdvListingForm.querySelector("[data-calc-received]");

    // Service Expert : visible uniquement si prix > 0 ET case cochée
    const showExpert = price > 0 && expertChecked;
    if (calcExpertRow) calcExpertRow.hidden = !showExpert;

    if (price > 0) {
      const commissionPlateforme = Math.round(price * currentCategoryBps()) / 10000;
      const fraisTraitement = Math.round(price * _fraisTraitementBps) / 10000;
      const expertDeduction = showExpert ? _expertMontantCents / 100 : 0;
      const net = price - commissionPlateforme - fraisTraitement - expertDeduction;

      if (calcPrice) calcPrice.textContent = formatEuros(price);
      if (calcCommission) calcCommission.textContent = "- " + formatEuros(commissionPlateforme);
      if (calcFrais) calcFrais.textContent = "- " + formatEuros(fraisTraitement);
      if (calcExpert) calcExpert.textContent = "- " + formatEuros(_expertMontantCents / 100);
      if (calcReceived) calcReceived.textContent = formatEuros(Math.max(0, net));
      return;
    }

    [calcPrice, calcCommission, calcFrais, calcReceived].forEach(function (node) {
      if (node) node.textContent = "—";
    });
  }

  // Afficher/masquer le panneau expert selon le prix
  function updateExpertPanel() {
    const price = Number(priceInput?.value || 0);
    const expertPanel = document.getElementById("sdv-expert-panel");
    const expertCheckbox = document.getElementById("sdv-expert-checkbox");
    if (!expertPanel) return;
    if (_expertConsultationActif && price > _expertSeuilCents / 100) {
      expertPanel.hidden = false;
    } else {
      expertPanel.hidden = true;
      if (expertCheckbox) expertCheckbox.checked = false;
    }
    updatePriceCalc();
  }

  // Mise à jour du calcul quand la case expert est cochée/décochée
  document.getElementById("sdv-expert-checkbox")?.addEventListener("change", updatePriceCalc);

  const subcatCardsWrap = sdvListingForm.querySelector("[data-subcat-cards]");

  function renderSubcatCards(key) {
    if (!subcatCardsWrap) return;
    subcatCardsWrap.innerHTML = "";
    if (subcatSelect) subcatSelect.value = "";
    (subcats[key] || []).forEach((subcat) => {
      const val = slugify(subcat);
      const lbl = document.createElement("label");
      lbl.className = "sdv-listing-cat sdv-listing-cat--small";
      lbl.innerHTML = '<input type="radio" name="subcat_card" value="' + val + '">'
        + '<span class="sdv-listing-cat__name">' + subcat + '</span>';
      lbl.querySelector("input").addEventListener("change", function () {
        if (subcatSelect) subcatSelect.value = val;
        if (subcategoryValue) subcategoryValue.value = subcat;
        updateIntroState();
      });
      subcatCardsWrap.appendChild(lbl);
    });
  }

  sdvListingForm.querySelectorAll("input[name='listing_category']").forEach((radio) => {
    radio.addEventListener("change", () => {
      selectedCategoryLabel = radio.dataset.label || radio.value;
      const key = radio.dataset.subcat || "";
      renderSubcatCards(key);
      subcatWrap?.classList.add("is-visible");
      if (sidebarCategory) sidebarCategory.textContent = selectedCategoryLabel;
      if (categoryValue) categoryValue.value = selectedCategoryLabel;
      if (categoryHandle) categoryHandle.value = radio.value;
      if (subcatSelect) subcatSelect.value = "";
      updateIntroState();
      // Appel après avoir mis à jour la catégorie
      updateFormForCategory(radio.value);
    });
  });

  startButton?.addEventListener("click", () => {
    if (startButton.hasAttribute("disabled")) return;
    if (intro) intro.hidden = true;
    if (shell) shell.hidden = false;
    goToStep(1);
  });

  backIntroButton?.addEventListener("click", () => {
    if (shell) shell.hidden = true;
    if (intro) intro.hidden = false;
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  titleInput?.addEventListener("input", () => {
    if (sidebarTitle) sidebarTitle.textContent = titleInput.value.trim() || SDV_T("listing.newProduct", "Nouveau produit");
  });

  // ── État de l'article : obligatoire ───────────────────────────────────────
  // Le formulaire est en novalidate : l'attribut « required » des boutons
  // d'état n'était vérifié par personne, et des annonces arrivaient en
  // modération sans état. On le contrôle à la sortie de l'étape 1 et à
  // l'envoi ; le serveur le refuse de toute façon. Nouvelles annonces
  // seulement : en édition (editMode), une annonce déposée avant qu'il soit
  // demandé reste modifiable sans état.
  const conditionError = sdvListingForm.querySelector("[data-condition-error]");
  function etatChoisi() {
    return Boolean(sdvListingForm.querySelector('input[name="condition"]:checked'));
  }
  function signalerEtatManquant() {
    if (conditionError) conditionError.hidden = false;
    if (currentStep !== 1) goToStep(1);
    const premier = sdvListingForm.querySelector('input[name="condition"]');
    // Après le défilement vers le haut déclenché par goToStep.
    setTimeout(() => {
      premier?.closest(".contact-form__row")?.scrollIntoView({ behavior: "smooth", block: "center" });
      premier?.focus({ preventScroll: true });
    }, 60);
  }
  sdvListingForm.querySelectorAll('input[name="condition"]').forEach((champ) => {
    champ.addEventListener("change", () => { if (conditionError) conditionError.hidden = true; });
  });

  sdvListingForm.querySelectorAll("[data-next-step]").forEach((button) => {
    button.addEventListener("click", () => {
      const next = Number(button.dataset.nextStep || currentStep + 1);
      if (!editMode && currentStep === 1 && next > 1 && !etatChoisi()) {
        signalerEtatManquant();
        return;
      }
      goToStep(next);
    });
  });

  sdvListingForm.querySelectorAll("[data-prev-step]").forEach((button) => {
    button.addEventListener("click", () => {
      const previous = Number(button.dataset.prevStep || currentStep - 1);
      goToStep(previous);
    });
  });

  // Navigation via les labels de progression (étapes déjà visitées seulement)
  sdvListingForm.querySelectorAll("[data-step-nav]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const navStep = Number(btn.dataset.stepNav || 0);
      if (navStep > 0 && navStep <= maxVisitedStep) goToStep(navStep);
    });
  });

  priceInput?.addEventListener("input", updateExpertPanel);
  priceInput?.addEventListener("change", updateExpertPanel);
  updateExpertPanel(); // appel initial — force l'état correct dès le rendu

  // ── Catégorie colis → bascule sur devis si fragile ou furniture ───────────
  const devisFields = document.getElementById("sdv-devis-fields");
  const shippingModeHidden = sdvListingForm.querySelector("[data-shipping-mode-hidden]");
  const devisWeightInput = sdvListingForm.querySelector("[data-devis-weight]");
  const DEVIS_TIERS = ["fragile", "furniture"];
  // Le poids est demandé pour tous les paliers transporteur, pas seulement le
  // grand colis : sans lui, l'envoi partait au poids par défaut du palier
  // (0,5 kg en petit colis) et le centre de tri refusait le colis à l'arrivée.
  const DETAILED_PACKAGE_TIERS = ["small", "medium", "large", ...DEVIS_TIERS];
  // Repères concrets, emballage compris : un vendeur qui ne pèse pas son colis
  // saisissait n'importe quoi, ou rien.
  const EXEMPLES_POIDS = {
    small: "Repères, emballage compris : lunettes ≈ 0,3 kg · chemise ≈ 0,6 kg · sac à main ≈ 1,2 kg · paire de chaussures ≈ 1,5 kg",
    medium: "Repères, emballage compris : manteau ≈ 2,5 kg · bottes ≈ 3 kg · sac de voyage ≈ 4 kg · petite lampe ≈ 6 kg",
    large: "Repères, emballage compris : valise ≈ 12 kg · tapis roulé ≈ 15 kg · chaise ≈ 20 kg",
    fragile: "Même approximatif, le poids aide à chiffrer le devis.",
    furniture: "Même approximatif, le poids aide à chiffrer le devis.",
  };
  // Limite des transporteurs colis (Colissimo plafonne à 30 kg). Au-delà,
  // aucune méthode d'expédition ne correspond au poids : la cotation et
  // l'étiquette seraient fausses. Même valeur que POIDS_COLIS_MAX_KG côté serveur.
  const POIDS_COLIS_MAX_KG = 30;

  function updateTierMode() {
    const tier = sdvListingForm.querySelector("input[name='shippingTier']:checked")?.value || "";
    const isDevis = DEVIS_TIERS.includes(tier);
    const needsPackageDetails = DETAILED_PACKAGE_TIERS.includes(tier);
    // Tout palier transporteur exige le poids (le serveur l'exige aussi).
    // Fragile et meuble passent sur devis : poids facultatif. Les dimensions
    // ne sont demandées nulle part.
    const detailsObligatoires = !isDevis;
    if (devisFields) devisFields.hidden = !needsPackageDetails;
    if (shippingModeHidden) shippingModeHidden.value = isDevis ? "quote" : "ship_or_pickup";
    if (devisWeightInput) devisWeightInput.required = detailsObligatoires;
    const exemples = sdvListingForm.querySelector("[data-weight-exemples]");
    if (exemples) exemples.textContent = EXEMPLES_POIDS[tier] || "";
    sdvListingForm.querySelectorAll("[data-details-obligatoire]").forEach((el) => { el.hidden = !detailsObligatoires; });
    sdvListingForm.querySelectorAll("[data-details-facultatif]").forEach((el) => { el.hidden = detailsObligatoires; });
  }

  function majAlertePoids() {
    const alerte = sdvListingForm.querySelector("[data-weight-warning]");
    if (alerte) alerte.hidden = poidsSaisiValide();
  }

  sdvListingForm.querySelectorAll("[data-tier]").forEach(function (radio) {
    radio.addEventListener("change", function () { updateTierMode(); majAlertePoids(); });
  });
  updateTierMode();

  function messagePoidsExcessif() {
    return SDV_T(
      "listing.weightMax",
      "Un colis transporteur ne peut pas dépasser " + POIDS_COLIS_MAX_KG + " kg. Au-delà, choisissez « Meuble / volumineux » : la livraison sera chiffrée sur devis."
    );
  }

  // Le plafond ne vaut que pour les paliers cotés par un transporteur. Un
  // meuble « sur devis » est chiffré à la main et peut être plus lourd.
  function poidsSaisiValide() {
    const tier = sdvListingForm.querySelector("input[name='shippingTier']:checked")?.value || "";
    if (DEVIS_TIERS.includes(tier)) return true;
    const poids = parseFloat(devisWeightInput?.value || "");
    return !(poids > POIDS_COLIS_MAX_KG);
  }

  // Le formulaire est en novalidate : on affiche l'alerte nous-mêmes.
  devisWeightInput?.addEventListener("input", majAlertePoids);

  // ── Preuve d'authenticité ─────────────────────────────────────────────────
  let proofImageBase64 = "";
  const proofTrigger = sdvListingForm.querySelector("[data-proof-trigger]");
  const proofInput = sdvListingForm.querySelector("[data-proof-input]");
  const proofPreview = sdvListingForm.querySelector("[data-proof-preview]");
  const proofImg = sdvListingForm.querySelector("[data-proof-img]");
  const proofRemove = sdvListingForm.querySelector("[data-proof-remove]");

  proofTrigger?.addEventListener("click", () => proofInput?.click());
  proofInput?.addEventListener("change", async () => {
    const file = proofInput.files?.[0];
    if (!file) return;
    if (file.size > 5_000_000) { alert(SDV_T("listing.fileTooBig", "Le fichier est trop volumineux (max 5 Mo).")); proofInput.value = ""; return; }
    try {
      proofImageBase64 = await preparerImage(file);
      if (proofImg) proofImg.src = proofImageBase64;
      if (proofPreview) proofPreview.hidden = false;
      if (proofTrigger) proofTrigger.style.display = "none";
    } catch { proofImageBase64 = ""; }
  });
  proofRemove?.addEventListener("click", () => {
    proofImageBase64 = "";
    if (proofInput) proofInput.value = "";
    if (proofPreview) proofPreview.hidden = true;
    if (proofTrigger) proofTrigger.style.display = "";
  });

  // Affiche la section preuve uniquement si le toggle certificat est coché
  const certCheckbox = sdvListingForm.querySelector("#sdv-has-certificate");
  const proofSection = sdvListingForm.querySelector("[data-proof-section]");
  function syncProofSection() {
    if (!proofSection) return;
    proofSection.hidden = !certCheckbox?.checked;
    if (!certCheckbox?.checked) {
      proofImageBase64 = "";
      if (proofInput) proofInput.value = "";
      if (proofPreview) proofPreview.hidden = true;
      if (proofTrigger) proofTrigger.style.display = "";
    }
  }
  certCheckbox?.addEventListener("change", syncProofSection);

  // ── Mode édition (?edit=HANDLE) ────────────────────────────────────────────
  let editMode = false;
  let editHandle = null;
  const urlParams = new URLSearchParams(window.location.search);
  const editParam = urlParams.get("edit");

  if (editParam) {
    editMode = true;
    // L'état du produit reste obligatoire à la création. En édition, une
    // annonce déposée avant l'ajout de ce champ n'en a pas : l'exiger
    // empêcherait son vendeur de corriger ne serait-ce que son prix.
    sdvListingForm.querySelectorAll('input[name="condition"][required]')
      .forEach((champ) => champ.removeAttribute("required"));
    editHandle = editParam;

    // Charger les données du produit à éditer
    fetch(proxyBase + "/seller/products/" + encodeURIComponent(editParam), { credentials: "same-origin" })
      .then((r) => r.ok ? r.json() : r.json().then((d) => Promise.reject(new Error(d.erreur || "Produit introuvable."))).catch(() => Promise.reject(new Error("Produit introuvable."))))
      .then((productData) => {
        // 1. Basculer immédiatement sur le formulaire (avant tout pré-remplissage),
        //    pour ne jamais laisser l'utilisateur bloqué sur l'intro si une étape échoue.
        if (intro) intro.hidden = true;
        if (shell) shell.hidden = false;
        maxVisitedStep = 5;

        const editBanner = sdvListingForm.querySelector("[data-edit-banner]");
        if (editBanner) editBanner.hidden = false;
        const step1Title = sdvListingForm.querySelector("[data-listing-step1-title]");
        if (step1Title) step1Title.textContent = SDV_T("listing.editTitle", "Modifier votre annonce.");

        try {
          // Pré-sélectionner la catégorie
          const cat = productData.listing_category;
          if (cat) {
            const catRadio = sdvListingForm.querySelector("input[name='listing_category'][value='" + cat + "']");
            if (catRadio) { catRadio.checked = true; catRadio.dispatchEvent(new Event("change", { bubbles: true })); }
          }

          // Pré-sélectionner la sous-catégorie (après le rendu des cartes sous-cat)
          if (productData.subCategory) {
            const subcatSlug = String(productData.subCategory).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"").replace(/[^a-z0-9]+/g,"-").replace(/^-|-$/g,"");
            setTimeout(() => {
              const subcatCard = sdvListingForm.querySelector("input[name='subcat_card'][value='" + subcatSlug + "']");
              if (subcatCard) { subcatCard.checked = true; subcatCard.dispatchEvent(new Event("change", { bubbles: true })); }
            }, 0);
          }

          // Pré-remplir tous les champs
          const formEl = sdvListingForm.querySelector("form[data-listing-submit]");
          if (formEl) {
            const setField = (name, value) => {
              if (value == null || value === "") return;
              // Groupe de boutons radio (état du produit…) : il faut cocher
              // celui qui correspond, pas écraser la valeur du premier — ce que
              // faisait la version précédente, corrompant au passage le premier
              // choix du groupe.
              const radios = formEl.querySelectorAll("input[type='radio'][name='" + name + "']");
              if (radios.length) {
                radios.forEach((r) => {
                  if (r.value === String(value)) {
                    r.checked = true;
                    r.dispatchEvent(new Event("change", { bubbles: true }));
                  }
                });
                return;
              }
              const el = formEl.querySelector("[name='" + name + "']");
              if (el) el.value = value;
            };
            setField("name", productData.name);
            setField("description", productData.description);
            setField("price", productData.price);
            setField("quantity", productData.quantity);
            setField("sku", productData.sku);
            setField("brand", productData.brand);
            setField("color", productData.color);
            setField("decade", productData.decade);
            setField("size", productData.size);
            setField("condition", productData.condition);

            const certCb = formEl.querySelector("#sdv-has-certificate");
            if (certCb) { certCb.checked = Boolean(productData.hasCertificate); certCb.dispatchEvent(new Event("change")); }
            const idCb = formEl.querySelector("#sdv-accept-identification");
            if (idCb) idCb.checked = Boolean(productData.acceptIdentification);
          }

          if (sidebarTitle && productData.name) sidebarTitle.textContent = productData.name;

          // Message modérateur dans le bandeau (DOM sûr, sans innerHTML)
          if (productData.moderationMessage && productData.moderationStatut === "revision-demandee" && editBanner) {
            const msgP = document.createElement("p");
            msgP.style.cssText = "margin:6px 0 0;font-size:12px;opacity:0.85;";
            const em = document.createElement("em");
            em.textContent = productData.moderationMessage;
            msgP.appendChild(document.createTextNode("Message de notre équipe : "));
            msgP.appendChild(em);
            editBanner.appendChild(msgP);
          }
        } catch (err) {
          console.warn("Pré-remplissage partiel:", err);
        }

        // Photos déjà en ligne : elles remplissent les emplacements, pour que le
        // vendeur voie son annonce telle qu'elle est et ne les re-téléverse pas.
        chargerPhotosExistantes(productData.images);
        syncProofSection();
        updateExpertPanel(); // appelle updatePriceCalc en interne
        updateTierMode();
        goToStep(1);
      })
      .catch((err) => {
        console.error("Édition produit:", err);
        alert("Impossible de charger ce produit pour édition : " + (err?.message || "erreur inconnue"));
      });
  }

  // ── Brouillon automatique (localStorage) ──────────────────────────────────
  const DRAFT_KEY = "sdv-product-draft";
  const DRAFT_TTL = 7 * 24 * 60 * 60 * 1000;

  function saveDraft() {
    if (!shell || shell.hidden) return;
    try {
      const formEl = sdvListingForm.querySelector("form[data-listing-submit]");
      if (!formEl) return;
      const draft = { _v: 1, _step: currentStep, _maxStep: maxVisitedStep, _at: Date.now(), f: {} };
      formEl.querySelectorAll("[name]").forEach((el) => {
        if (el.type === "file") return;
        if (el.type === "radio") { if (el.checked) draft.f[el.name] = el.value; }
        else if (el.type === "checkbox") { draft.f["cb:" + el.name + ":" + el.value] = el.checked; }
        else { draft.f[el.name] = el.value; }
      });
      draft._cat = sdvListingForm.querySelector("[data-listing-category-handle]")?.value || "";
      draft._subcat = sdvListingForm.querySelector("[data-listing-subcategory-value]")?.value || "";
      draft._catLabel = selectedCategoryLabel || "";
      draft._title = sdvListingForm.querySelector("input[name='name']")?.value || "";
      localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch(e) {}
  }

  function clearDraft() { try { localStorage.removeItem(DRAFT_KEY); } catch(e) {} }

  function loadDraft() {
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      const d = JSON.parse(raw);
      if (!d._cat || !d._v) return null;
      if (Date.now() - (d._at || 0) > DRAFT_TTL) { clearDraft(); return null; }
      return d;
    } catch(e) { return null; }
  }

  function restoreDraft(draft) {
    const catRadio = sdvListingForm.querySelector("input[name='listing_category'][value='" + draft._cat + "']");
    if (!catRadio) return;
    catRadio.checked = true;
    catRadio.dispatchEvent(new Event("change", { bubbles: true }));
    if (draft._subcat) {
      const subcatCard = sdvListingForm.querySelector("input[name='subcat_card'][value='" + draft._subcat + "']");
      if (subcatCard) { subcatCard.checked = true; subcatCard.dispatchEvent(new Event("change", { bubbles: true })); }
    }
    if (intro) intro.hidden = true;
    if (shell) shell.hidden = false;
    maxVisitedStep = Math.max(1, draft._maxStep || 1);
    const formEl = sdvListingForm.querySelector("form[data-listing-submit]");
    if (formEl) {
      formEl.querySelectorAll("[name]").forEach((el) => {
        if (el.type === "file" || el.type === "hidden") return;
        if (el.type === "radio") {
          if (draft.f[el.name] !== undefined) el.checked = (el.value === draft.f[el.name]);
        } else if (el.type === "checkbox") {
          const k = "cb:" + el.name + ":" + el.value;
          if (draft.f[k] !== undefined) el.checked = !!draft.f[k];
        } else {
          if (draft.f[el.name] !== undefined) el.value = draft.f[el.name] || "";
        }
      });
    }
    const nameVal = sdvListingForm.querySelector("input[name='name']")?.value;
    if (nameVal && sidebarTitle) sidebarTitle.textContent = nameVal;
    syncProofSection();
    updateExpertPanel(); // appelle updatePriceCalc en interne
    updateTierMode();
    goToStep(draft._step || 1);
  }

  // Afficher la bannière si brouillon valide
  const draftBanner = sdvListingForm.querySelector("[data-draft-banner]");
  const draftBannerInfo = sdvListingForm.querySelector("[data-draft-banner-info]");
  const savedDraft = loadDraft();
  if (savedDraft && draftBanner) {
    const hoursAgo = Math.floor((Date.now() - savedDraft._at) / 3600000);
    const daysAgo = Math.floor(hoursAgo / 24);
    const timeLabel = daysAgo > 0 ? ("il y a " + daysAgo + " j") : (hoursAgo > 0 ? ("il y a " + hoursAgo + "h") : "il y a moins d'1h");
    if (draftBannerInfo) {
      draftBannerInfo.textContent = (savedDraft._title || SDV_T("listing.untitled", "Sans titre")) + " · " + (savedDraft._catLabel || savedDraft._cat) + " · " + timeLabel;
    }
    draftBanner.hidden = false;
    sdvListingForm.querySelector("[data-draft-restore]")?.addEventListener("click", () => {
      draftBanner.hidden = true;
      restoreDraft(savedDraft);
    });
    sdvListingForm.querySelector("[data-draft-discard]")?.addEventListener("click", () => {
      clearDraft();
      draftBanner.hidden = true;
    });
  }

  // Auto-save sur les changements de champs (debounced)
  let _draftTimer = null;
  sdvListingForm.querySelector("form[data-listing-submit]")?.addEventListener("input", () => {
    clearTimeout(_draftTimer); _draftTimer = setTimeout(saveDraft, 800);
  });
  sdvListingForm.querySelector("form[data-listing-submit]")?.addEventListener("change", () => {
    clearTimeout(_draftTimer); _draftTimer = setTimeout(saveDraft, 800);
  });

  // ── Photos : un emplacement = une image, ajoutées une par une ──────────────
  // Chaque case est indépendante. Une nouvelle sélection complète les cases
  // libres au lieu de tout remplacer : les vendeurs chargent leurs photos une
  // à une, et la version précédente écrasait la sélection à chaque fois.
  const photoSlots = Array.from(sdvListingForm.querySelectorAll("[data-photo-slot]"));
  const MAX_PHOTOS = photoSlots.length;
  const selectedImageAttachments = new Array(MAX_PHOTOS).fill(null); // base64 par case
  const photoPreviewUrls = new Array(MAX_PHOTOS).fill(null);
  const photoSlotHtmlInitial = photoSlots.map((slot) => slot.innerHTML);
  let slotCible = null; // case sur laquelle l'utilisateur a cliqué

  function photosChoisies() {
    return selectedImageAttachments.filter(Boolean);
  }

  function prochaineCaseLibre(depuis) {
    for (let i = depuis || 0; i < MAX_PHOTOS; i++) {
      if (!selectedImageAttachments[i]) return i;
    }
    return null;
  }

  function viderCase(index) {
    if (photoPreviewUrls[index]) {
      URL.revokeObjectURL(photoPreviewUrls[index]);
      photoPreviewUrls[index] = null;
    }
    selectedImageAttachments[index] = null;
    const slot = photoSlots[index];
    if (!slot) return;
    slot.innerHTML = photoSlotHtmlInitial[index];
    slot.classList.remove("is-filled");
    majCompteurPhotos();
  }

  /** Affiche une photo déjà en ligne dans son emplacement (mode édition). */
  function afficherApercuUrl(index, url) {
    const slot = photoSlots[index];
    if (!slot || !url) return;
    const img = document.createElement("img");
    img.src = url;
    img.alt = "";
    const retirer = document.createElement("span");
    retirer.className = "sdv-listing-photo-remove";
    retirer.setAttribute("role", "button");
    retirer.setAttribute("tabindex", "0");
    retirer.setAttribute("aria-label", SDV_T("listing.removePhoto", "Retirer cette photo"));
    retirer.textContent = "×";
    const supprimer = (event) => { event.preventDefault(); event.stopPropagation(); viderCase(index); };
    retirer.addEventListener("click", supprimer);
    retirer.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") supprimer(event);
    });
    slot.innerHTML = "";
    slot.appendChild(img);
    slot.appendChild(retirer);
    slot.classList.add("is-filled");
  }

  /**
   * Charge les photos existantes dans le formulaire d'édition.
   *
   * Sans cela le vendeur voyait des emplacements vides alors que son annonce a
   * des photos, et les re-téléversait toutes — ce qui déclenchait une
   * remodération pour rien. Les URLs déjà hébergées sont conservées telles
   * quelles : renvoyées à l'identique, le serveur les reconnaît inchangées.
   */
  function chargerPhotosExistantes(urls) {
    if (!Array.isArray(urls)) return;
    urls.slice(0, MAX_PHOTOS).forEach((url, index) => {
      if (!url) return;
      selectedImageAttachments[index] = url;
      afficherApercuUrl(index, url);
    });
    majCompteurPhotos();
  }

  function afficherApercu(index, file) {
    const slot = photoSlots[index];
    if (!slot) return;
    if (photoPreviewUrls[index]) URL.revokeObjectURL(photoPreviewUrls[index]);
    const url = URL.createObjectURL(file);
    photoPreviewUrls[index] = url;

    const img = document.createElement("img");
    img.src = url;
    img.alt = file.name;

    // Croix de suppression : un <span>, pas un <button>, la case étant elle-même
    // un bouton (imbrication interdite en HTML).
    const retirer = document.createElement("span");
    retirer.className = "sdv-listing-photo-remove";
    retirer.setAttribute("role", "button");
    retirer.setAttribute("tabindex", "0");
    retirer.setAttribute("aria-label", SDV_T("listing.removePhoto", "Retirer cette photo"));
    retirer.textContent = "×";
    const supprimer = (event) => {
      event.preventDefault();
      event.stopPropagation();
      viderCase(index);
    };
    retirer.addEventListener("click", supprimer);
    retirer.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") supprimer(event);
    });

    slot.innerHTML = "";
    slot.appendChild(img);
    slot.appendChild(retirer);
    slot.classList.add("is-filled");
  }

  function majCompteurPhotos() {
    const compteur = sdvListingForm.querySelector("[data-photo-count]");
    if (compteur) {
      compteur.textContent = photosChoisies().length + " / " + MAX_PHOTOS;
    }
  }

  photoInput?.addEventListener("change", async () => {
    const files = Array.from(photoInput.files || []);
    // Vider l'input tout de suite : sans cela, re-choisir le même fichier
    // ne déclenche aucun évènement « change ».
    photoInput.value = "";
    if (!files.length) { slotCible = null; return; }

    let index = slotCible !== null ? slotCible : prochaineCaseLibre(0);
    slotCible = null;
    let ajoutees = 0;
    let refusees = 0;

    for (const file of files) {
      if (index === null) { refusees++; continue; }
      try {
        const base64 = await preparerImage(file);
        selectedImageAttachments[index] = base64;
        afficherApercu(index, file);
        ajoutees++;
      } catch (error) {
        console.warn("Préparation de l'image impossible :", error);
        setStatus(SDV_T("listing.imagePrepError", "Une image n'a pas pu être préparée."), "error");
      }
      index = prochaineCaseLibre(index + 1);
    }

    majCompteurPhotos();
    if (refusees > 0) {
      setStatus(
        SDV_T("listing.photoLimit", "Maximum " + MAX_PHOTOS + " photos : les suivantes ont été ignorées."),
        "error"
      );
    } else if (ajoutees > 0) {
      setStatus(
        photosChoisies().length + " " + SDV_T("listing.photoCount", "photo(s) prête(s) à être envoyée(s)."),
        ""
      );
    }
  });

  photoSlots.forEach((slot, index) => {
    slot.addEventListener("click", (event) => {
      // La croix gère sa propre action.
      if (event.target.closest && event.target.closest(".sdv-listing-photo-remove")) return;
      slotCible = index;
      photoInput?.click();
    });
  });
  majCompteurPhotos();

  submitForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    setStatus(SDV_T("listing.sending", "Envoi en cours..."), "");
    const submit = submitForm.querySelector("button[type='submit']");
    submit?.setAttribute("disabled", "disabled");

    try {
      // Filet final : un brouillon restauré peut amener directement aux
      // dernières étapes, sans repasser par l'étape 1. L'édition d'une annonce
      // existante n'est pas concernée.
      if (!editMode && !etatChoisi()) {
        setStatus(SDV_T("listing.conditionRequired", "Indiquez l'état de votre article."), "error");
        submit?.removeAttribute("disabled");
        signalerEtatManquant();
        return;
      }
      if (!poidsSaisiValide()) {
        setStatus(messagePoidsExcessif(), "error");
        submit?.removeAttribute("disabled");
        goToStep(4);
        devisWeightInput?.focus();
        return;
      }
      const formData = new FormData(submitForm);
      const payload = Object.fromEntries(formData.entries());
      payload.tags = [
        filterTag("sdv-cat", payload.listing_category),
        filterTag("sdv-subcat", payload.subCategory),
        // sdv-brand : ajouté côté serveur via la liste de référence (marque canonique)
        filterTag("sdv-size", payload.size),
        filterTag("sdv-condition", payload.condition),
        filterTag("sdv-color", payload.color),
        filterTag("sdv-decade", payload.decade),
        filterTag("sdv-shipping-mode", payload.shippingMode),
        filterTag("sdv-shipping-tier", payload.shippingTier),
        (payload.shippingMode === "quote" || payload.shippingTier === "furniture") ? "sdv-shipping-devis" : "",
        payload.isFragile ? "sdv-shipping:fragile" : "",
        payload.isVintage ? "sdv-flag:vintage-authentique" : "",
        payload.hasCertificate ? "sdv-flag:certificat-disponible" : "",
        // Phase 2 — tags catégorie-spécifiques
        filterTag("sdv-artiste", payload.artiste),
        filterTag("sdv-label", payload.label),
        filterTag("sdv-materiaux", payload.materiaux),
        filterTag("sdv-marque-vehicule", payload.marqueVehicule),
      ].filter(Boolean).join(", ");

      // Phase 2 — enrichissement description avec les champs spécifiques
      const ficheLines = [];
      if (payload.artiste) ficheLines.push("Artiste : " + payload.artiste);
      if (payload.label) ficheLines.push("Label : " + payload.label);
      if (payload.referenceCat) ficheLines.push("Réf. catalogue : " + payload.referenceCat);
      if (payload.reference) ficheLines.push("Réf. / N° série : " + payload.reference);
      if (payload.materiaux) ficheLines.push("Matériaux : " + payload.materiaux);
      if (payload.marqueVehicule) ficheLines.push("Marque : " + payload.marqueVehicule);
      if (payload.modeleVehicule) ficheLines.push("Modèle : " + payload.modeleVehicule);
      if (payload.anneeVehicule) ficheLines.push("Année : " + payload.anneeVehicule);
      if (ficheLines.length > 0 && payload.description) {
        payload.description = ficheLines.join(" · ") + "\n\n" + payload.description;
      }

      // Auto-Moto : isVintage forcé
      if (payload.listing_category === "auto-moto-vintage") payload.isVintage = "true";

      payload.sku = payload.sku || `SDV-${Date.now()}`;

      // ── Upload images une par une vers Shopify Files (évite FUNCTION_PAYLOAD_TOO_LARGE) ──
      async function uploadOneImage(dataUrl, prefix, alt) {
        const res = await fetch(proxyBase + "/seller/upload-image", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ imageData: dataUrl, prefix: prefix || "product", alt: alt || "Photo" }),
        });
        // Un refus de la plateforme (charge trop lourde) ne renvoie pas de JSON :
        // sans ce cas, le vendeur ne voyait qu'un message générique sans piste.
        if (res.status === 413) {
          throw new Error(SDV_T(
            "listing.imageTooLarge",
            "Cette photo est trop lourde. Réduisez-la (environ 2 Mo maximum) puis réessayez."
          ));
        }
        const d = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(d.erreur || SDV_T("listing.imageUploadError", "Upload image impossible."));
        return d.url;
      }

      const photosAEnvoyer = photosChoisies();
      // Une annonce sans photo ne se vend pas : on l'arrête avant l'envoi
      // plutôt que de laisser le vendeur découvrir le refus du serveur, ou
      // pire, la voir publiée vide. Le serveur applique la même règle.
      if (photosAEnvoyer.length === 0 && !editMode) {
        setStatus(SDV_T("listing.photoRequired", "Ajoutez au moins une photo de votre article."), "error");
        submit?.removeAttribute("disabled");
        return;
      }
      if (photosAEnvoyer.length > 0) {
        setStatus("Upload des photos (" + photosAEnvoyer.length + ")…", "");
        const imageUrls = [];
        for (let i = 0; i < photosAEnvoyer.length; i++) {
          // Une photo déjà en ligne est une URL : on la garde telle quelle.
          // Seules les nouvelles (data:) sont téléversées.
          if (!String(photosAEnvoyer[i]).startsWith("data:")) {
            imageUrls.push(photosAEnvoyer[i]);
            continue;
          }
          setStatus("Upload photo " + (i + 1) + " / " + photosAEnvoyer.length + "…", "");
          const url = await uploadOneImage(photosAEnvoyer[i], "product", payload.name || "Photo");
          imageUrls.push(url);
        }
        payload.imageUrls = imageUrls;
        // Ne plus envoyer les base64
        delete payload.imageAttachments;
      }

      // Upload preuve d'authenticité
      if (proofImageBase64) {
        try {
          setStatus(SDV_T("listing.uploadingProof", "Upload de la preuve…"), "");
          payload.proofImageUrl = await uploadOneImage(proofImageBase64, "proof", "Preuve authenticité");
        } catch (err) {
          console.warn("Upload preuve échoué (ignoré):", err);
        }
      }

      setStatus(SDV_T("listing.sending", "Envoi en cours…"), "");
      const submitUrl = editMode && editHandle
        ? `${proxyBase}/seller/products/${encodeURIComponent(editHandle)}`
        : `${proxyBase}/products`;
      const submitMethod = editMode ? "PUT" : "POST";
      const response = await fetch(submitUrl, {
        method: submitMethod,
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.erreur || (editMode ? SDV_T("listing.updateError", "Mise à jour impossible.") : SDV_T("listing.createError", "Création impossible.")));

      clearDraft();

      // Boost produit choisi à la mise en ligne : on enregistre l'intention.
      // Le produit étant en attente de validation, le paiement sera proposé après approbation.
      const boostTier = !editMode
        ? (sdvListingForm.querySelector("input[name='boostTier']:checked")?.value || "")
        : "";
      const newProductId = data && data.product ? String(data.product.id || "") : "";
      let boostMsg = "";
      if (boostTier && newProductId) {
        try {
          const br = await fetch(proxyBase + "/seller/boost/product", {
            method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ shopifyProductId: newProductId, tierKey: boostTier }),
          });
          const bd = await br.json().catch(() => ({}));
          if (br.ok && bd.invoiceUrl) { window.location.href = bd.invoiceUrl; return; }
          if (br.ok && bd.awaitingApproval) { boostMsg = " " + SDV_T("listing.boostAfterApproval", "Le paiement de votre boost vous sera proposé dès validation de l'annonce."); }
        } catch (e) { /* on retombe sur le retour espace vendeur */ }
      }

      setStatus(
        (editMode
          ? SDV_T("listing.resubmitted", "Annonce resoumise. Notre équipe va la revalider.")
          : SDV_T("listing.submitted", "Produit envoyé en validation.")) + (boostMsg || " " + SDV_T("listing.backToDashboard", "Retour à votre espace vendeur...")),
        "success"
      );
      setTimeout(() => {
        window.location.href = backUrl;
      }, boostMsg ? 1800 : 900);
    } catch (error) {
      setStatus(error.message || SDV_T("listing.submitError", "Erreur pendant l'envoi."), "error");
    } finally {
      submit?.removeAttribute("disabled");
    }
  });
}

// ─────────────────────────────────────────────────────────────
// Partage : copier le lien produit
// ─────────────────────────────────────────────────────────────
document.querySelectorAll("[data-copy-link]").forEach((btn) => {
  btn.addEventListener("click", async () => {
    const url = btn.dataset.url || location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const tmp = document.createElement("input");
      tmp.value = url; document.body.appendChild(tmp); tmp.select();
      document.execCommand("copy"); document.body.removeChild(tmp);
    }
    const fb = btn.querySelector("[data-copy-feedback]");
    if (fb) {
      fb.hidden = false;
      setTimeout(() => { fb.hidden = true; }, 1800);
    }
  });
});

// ─────────────────────────────────────────────────────────────
// Produits récemment vus (localStorage)
// ─────────────────────────────────────────────────────────────
(function () {
  // Titre et prix sont mémorisés déjà formatés, tels que la page les affichait.
  // Un historique unique faisait donc réapparaître un titre français sur /es/,
  // et un prix dans la devise d'une visite précédente — d'où des montants en
  // roupies vues une fois depuis un marché étranger. L'historique est donc
  // cloisonné par langue et par devise : ce qui s'affiche a été capté dans le
  // contexte où on le relit.
  const track0 = document.querySelector("[data-recently-viewed-track]");
  const contexte = (document.documentElement.lang || "fr").toLowerCase()
    + ":" + ((track0 && track0.dataset.rvCurrency) || "");
  const RV_KEY = "sdv_recently_viewed:" + contexte;
  const MAX = 8;

  function load() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || "[]"); }
    catch { return []; }
  }
  function save(items) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function esc(s) {
    return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  // 1) Tracker le produit courant
  const track = track0;
  let currentHandle = null;
  if (track) {
    currentHandle = track.dataset.rvHandle;
    const entry = {
      handle: track.dataset.rvHandle,
      url: track.dataset.rvUrl,
      title: track.dataset.rvTitle,
      price: track.dataset.rvPrice,
      imageUrl: track.dataset.rvImage,
      vendor: track.dataset.rvVendor,
    };
    let items = load().filter((i) => i.handle !== entry.handle);
    items.unshift(entry);
    items = items.slice(0, MAX + 1);
    save(items);
  }

  // 2) Rendre la grille (hors produit courant)
  const section = document.querySelector("[data-recently-viewed]");
  const grid = document.querySelector("[data-recently-viewed-grid]");
  if (!section || !grid) return;

  const items = load().filter((i) => i.handle !== currentHandle).slice(0, MAX);
  if (!items.length) return;

  grid.innerHTML = items.map((it) => `
    <article class="product-card">
      <a class="product-card__media" href="${esc(it.url || '#')}">
        ${it.imageUrl
          ? `<img src="${esc(it.imageUrl)}" alt="${esc(it.title)}" loading="lazy">`
          : '<div class="product-card__placeholder"></div>'}
      </a>
      <div class="product-card__info">
        <span class="product-card__brand">${esc(it.vendor)}</span>
        <span class="product-card__title"><a href="${esc(it.url || '#')}">${esc(it.title)}</a></span>
        <div class="product-card__prices">
          <span class="product-card__price-now">${esc(it.price)}</span>
        </div>
      </div>
    </article>
  `).join("");
  section.hidden = false;
})();

// ─────────────────────────────────────────────────────────────
// Page produit : Faire une offre + Poser une question (marketplace)
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector("[data-sdv-product-actions]");
  if (!root) return;
  const proxyBase = (root.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  const handle = root.dataset.productHandle || "";
  const loggedIn = root.dataset.loggedIn === "1";
  const loginUrl = root.dataset.loginUrl || "/account/login";

  const offerModal = document.querySelector("[data-offer-modal]");
  const questionModal = document.querySelector("[data-question-modal]");
  const devisModal = document.querySelector("[data-devis-modal]");

  function open(modal) {
    if (!loggedIn) { window.location.href = loginUrl; return; }
    if (modal) { modal.hidden = false; document.body.style.overflow = "hidden"; }
  }
  function closeAll() {
    [offerModal, questionModal, devisModal].forEach((m) => { if (m) m.hidden = true; });
    document.body.style.overflow = "";
  }

  root.querySelector("[data-open-offer]")?.addEventListener("click", () => open(offerModal));
  root.querySelector("[data-open-question]")?.addEventListener("click", () => open(questionModal));
  // Le bouton de devis existe à deux endroits : l'action principale de la
  // buybox pour une pièce sur devis, et l'ancien bouton secondaire. Ils vivent
  // hors du bloc de négociation, on les cherche donc dans toute la page.
  document.querySelectorAll("[data-open-devis]").forEach((el) => el.addEventListener("click", () => open(devisModal)));
  document.querySelectorAll("[data-nego-close]").forEach((el) => el.addEventListener("click", closeAll));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAll(); });

  async function postJson(path, body, statusEl, btn, okMsg) {
    if (statusEl) { statusEl.textContent = ""; statusEl.classList.remove("is-ok"); }
    btn?.setAttribute("disabled", "disabled");
    try {
      const r = await fetch(proxyBase + path, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.erreur || SDV_T("common.sendError", "Envoi impossible."));
      if (statusEl) { statusEl.textContent = okMsg; statusEl.classList.add("is-ok"); }
      if (data.coordonneesMasquees) alert(SDV_AVERTISSEMENT_COORDONNEES);
      setTimeout(closeAll, 1600);
    } catch (err) {
      if (statusEl) statusEl.textContent = err.message || SDV_T("common.error", "Erreur.");
    } finally {
      btn?.removeAttribute("disabled");
    }
  }

  // Offre
  const offerBtn = offerModal?.querySelector("[data-offer-submit]");
  offerBtn?.addEventListener("click", () => {
    const amount = parseFloat((offerModal.querySelector("[data-offer-amount]")?.value || "").replace(",", "."));
    const message = offerModal.querySelector("[data-offer-message]")?.value || "";
    const statusEl = offerModal.querySelector("[data-offer-status]");
    if (!(amount > 0)) { if (statusEl) statusEl.textContent = SDV_T("offer.invalidAmount", "Indiquez un montant valide."); return; }
    postJson("/offres", { productHandle: handle, montant: amount, message, locale: window.SDV_LANG }, statusEl, offerBtn, SDV_T("offer.sent", "Offre envoyée au vendeur ✓"));
  });

  // Question
  const qBtn = questionModal?.querySelector("[data-question-submit]");
  qBtn?.addEventListener("click", () => {
    const message = (questionModal.querySelector("[data-question-message]")?.value || "").trim();
    const statusEl = questionModal.querySelector("[data-question-status]");
    if (message.length < 2) { if (statusEl) statusEl.textContent = SDV_T("question.write", "Écrivez votre question."); return; }
    postJson("/questions", { productHandle: handle, message, locale: window.SDV_LANG }, statusEl, qBtn, SDV_T("question.sent", "Question envoyée ✓"));
  });

  // Devis livraison
  const devisBtn = devisModal?.querySelector("[data-devis-submit]");
  devisBtn?.addEventListener("click", () => {
    const postal = (devisModal.querySelector("[data-devis-postal]")?.value || "").trim();
    const ville = (devisModal.querySelector("[data-devis-ville]")?.value || "").trim();
    const pays = (devisModal.querySelector("[data-devis-country]")?.value || "FR").trim();
    const adresse = (devisModal.querySelector("[data-devis-address]")?.value || "").trim();
    const message = devisModal.querySelector("[data-devis-message]")?.value || "";
    const statusEl = devisModal.querySelector("[data-devis-status]");
    if (!postal) { if (statusEl) statusEl.textContent = SDV_T("devis.postalRequired", "Indiquez votre code postal."); return; }
    postJson("/devis", { productHandle: handle, destinationAdresse: adresse, destinationCodePostal: postal, destinationVille: ville, destinationPays: pays, message, locale: window.SDV_LANG }, statusEl, devisBtn, SDV_T("devis.requestSent", "Demande envoyée au vendeur ✓"));
  });
})();

// ─────────────────────────────────────────────────────────────
// Espace vendeur : Offres reçues + Messagerie (mini-chat)
// ─────────────────────────────────────────────────────────────
(function () {
  const dash = document.querySelector("[data-sdv-vendor-dashboard]");
  if (!dash) return;
  const proxyBase = (dash.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");

  function esc(s){return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}
  function eur(c){return (Number(c||0)/100).toLocaleString("fr-FR",{style:"currency",currency:"EUR"});}
  function dt(iso){try{return new Date(iso).toLocaleDateString("fr-FR",{day:"numeric",month:"short"});}catch{return"";}}
  const OFFRE_LABEL = { EN_ATTENTE:SDV_T("offer.st.pending","En attente"), ACCEPTEE:SDV_T("offer.st.acceptedPay","Acceptée · paiement en attente"), REFUSEE:SDV_T("offer.st.refused","Refusée"), CONTRE_PROPOSEE:SDV_T("offer.st.countered","Contre-proposée"), CONTRE_ACCEPTEE:SDV_T("offer.st.acceptedPay","Acceptée · paiement en attente"), CONTRE_REFUSEE:SDV_T("offer.st.refused","Refusée"), PAYEE:SDV_T("offer.st.paid","Payée ✓"), EXPIREE:SDV_T("offer.st.expired","Expirée"), ANNULEE:SDV_T("offer.st.cancelled","Annulée") };

  async function api(path, method, body){
    const r = await fetch(proxyBase+path,{method:method||"GET",credentials:"same-origin",headers:body?{"Content-Type":"application/json"}:undefined,body:body?JSON.stringify(body):undefined});
    const d = await r.json().catch(()=>({}));
    if(!r.ok){ const e = new Error(d.erreur||SDV_T("common.error","Erreur")); e.statut = r.status; throw e; }
    return d;
  }

  // ── Offres ──
  const offresList = dash.querySelector("[data-sdv-offres-list]");
  const offresEmpty = dash.querySelector("[data-sdv-offres-empty]");
  const offresBadge = dash.querySelector("[data-offres-badge]");

  function offreCard(o){
    const enAttente = o.statut === "EN_ATTENTE";
    let actions = "";
    if (enAttente) {
      actions = `<div class="sdv-offre__actions">
        <button class="sdv-offre__btn sdv-offre__btn--accept" data-act="accepter" data-id="${o.id}">Accepter ${eur(o.montant)}</button>
        <button class="sdv-offre__btn" data-act="refuser" data-id="${o.id}">Refuser</button>
        <button class="sdv-offre__btn" data-act="contre-toggle" data-id="${o.id}">Contre-proposer</button>
      </div>
      <div class="sdv-offre__counter" data-counter="${o.id}" hidden>
        <input type="number" min="1" step="1" placeholder="Votre prix €" data-counter-input="${o.id}">
        <button class="sdv-offre__btn sdv-offre__btn--accept" data-act="contre" data-id="${o.id}">Envoyer</button>
        <p class="sdv-offre-gain__simu" data-offre-simu="${o.id}" aria-live="polite"></p>
      </div>`;
    }
    return `<article class="sdv-offre">
      ${o.productImageUrl?`<img class="sdv-offre__img" src="${esc(o.productImageUrl)}" alt="">`:`<div class="sdv-offre__img"></div>`}
      <div>
        <p class="sdv-offre__title">${esc(o.productTitle)}</p>
        <p class="sdv-offre__prices"><strong>${eur(o.montant)}</strong><span class="sdv-offre__old">${eur(o.prixOriginal)}</span>${o.contreMontant?` · contre : <strong>${eur(o.contreMontant)}</strong>`:""}</p>
        <span class="sdv-offre__status">${OFFRE_LABEL[o.statut]||o.statut}</span>
        ${o.acheteurNom?` · <span style="font-size:12px;color:var(--pierre-500)">${esc(o.acheteurNom)}</span>`:""}
        ${o.message?`<p class="sdv-offre__msg">« ${esc(o.message)} »</p>`:""}
        ${sdvGainOffreHtml(o)}
        ${actions}
      </div>
    </article>`;
  }

  // Texte d'origine du bloc « aucune offre », à restaurer après une panne.
  const offresEmptyTexte = offresEmpty ? offresEmpty.innerHTML : "";

  async function loadOffres(){
    if(!offresList) return;
    try {
      const { offres } = await api("/seller/offres");
      const enAttente = offres.filter(o=>o.statut==="EN_ATTENTE").length;
      if(offresBadge){ offresBadge.textContent=enAttente; offresBadge.hidden = enAttente===0; }
      if(offres.length===0){ offresList.innerHTML=""; if(offresEmpty){ offresEmpty.innerHTML=offresEmptyTexte; offresEmpty.hidden=false; } return; }
      if(offresEmpty) offresEmpty.hidden=true;
      offresList.innerHTML = offres.map(offreCard).join("");
    } catch(e){
      // Un onglet Offres vide et un onglet Offres inaccessible se
      // ressemblaient : un vendeur déconnecté croyait n'avoir aucune offre.
      offresList.innerHTML="";
      if(offresEmpty){ offresEmpty.innerHTML = sdvErreurFil(e); offresEmpty.hidden=false; }
    }
  }

  sdvBrancherSimulationContre(offresList, "[data-counter-input]", "data-counter-input", api);

  offresList?.addEventListener("click", async (e)=>{
    const btn = e.target.closest("[data-act]"); if(!btn) return;
    const id = btn.dataset.id, act = btn.dataset.act;
    if(act==="contre-toggle"){ const c=offresList.querySelector(`[data-counter="${id}"]`); if(c) c.hidden=!c.hidden; return; }
    btn.setAttribute("disabled","disabled");
    try {
      if(act==="accepter") await api(`/seller/offres/${id}/accepter`,"POST",{});
      else if(act==="refuser") await api(`/seller/offres/${id}/refuser`,"POST",{});
      else if(act==="contre"){ const v=parseFloat((offresList.querySelector(`[data-counter-input="${id}"]`)?.value||"").replace(",",".")); if(!(v>0)){btn.removeAttribute("disabled");return;} await api(`/seller/offres/${id}/contre`,"POST",{contreMontant:v}); }
      await loadOffres();
    } catch(err){ alert(err.message||SDV_T("common.error","Erreur")); btn.removeAttribute("disabled"); }
  });

  // ── Devis expédition ──
  const devisList = dash.querySelector("[data-sdv-devis-list]");
  const devisEmpty = dash.querySelector("[data-sdv-devis-empty]");
  const devisBadge = dash.querySelector("[data-devis-badge]");
  const DEVIS_LBL = { EN_ATTENTE:SDV_T("devisS.st.pending","En attente de votre réponse"), PROPOSE:SDV_T("devisS.st.sent","Devis envoyé · en attente"), ACCEPTE:SDV_T("devisS.st.accepted","Accepté · paiement en attente"), REFUSE:SDV_T("devisS.st.refused","Refusé"), PAYE:SDV_T("devisS.st.paid","Payé ✓"), EXPIRE:SDV_T("devisS.st.expired","Expiré"), ANNULE:SDV_T("devisS.st.cancelled","Annulé") };

  function devisVendeurCard(d){
    const enAttente = d.statut==="EN_ATTENTE";
    let actions="";
    if(enAttente){
      actions=`<div class="sdv-offre__actions">
        <div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
          <input type="number" min="0.01" step="0.01" placeholder="Tarif livraison €" data-devis-montant-input="${d.id}" style="width:130px;padding:6px;border:1px solid #ccc;border-radius:4px;font-size:13px;">
          <input type="text" placeholder="Message (optionnel)" data-devis-msg-input="${d.id}" style="flex:1;padding:6px;border:1px solid #ccc;border-radius:4px;font-size:13px;">
          <button class="sdv-offre__btn sdv-offre__btn--accept" data-dact="proposer" data-id="${d.id}">Envoyer</button>
        </div>
        <button class="sdv-offre__btn" data-dact="refuser" data-id="${d.id}">Ne pas livrer</button>
      </div>`;
    }
    const dest=[d.destinationCodePostal,d.destinationVille,d.destinationPays].filter(Boolean).join(" ");
    return `<article class="sdv-offre">
      ${d.productImageUrl?`<img class="sdv-offre__img" src="${esc(d.productImageUrl)}" alt="">`:`<div class="sdv-offre__img"></div>`}
      <div>
        <p class="sdv-offre__title">${esc(d.productTitle)}</p>
        ${dest?`<p style="font-size:12px;color:var(--pierre-500)">Destination : ${esc(dest)}</p>`:""}
        ${d.messageAcheteur?`<p class="sdv-offre__msg">« ${esc(d.messageAcheteur)} »</p>`:""}
        <span class="sdv-offre__status">${DEVIS_LBL[d.statut]||d.statut}</span>
        ${d.montantLivraison?` · <strong>${eur(d.montantLivraison)}</strong> livraison`:""}
        ${d.acheteurNom?` · <span style="font-size:12px;color:var(--pierre-500)">${esc(d.acheteurNom)}</span>`:""}
        ${actions}
      </div>
    </article>`;
  }

  const devisEmptyTexte = devisEmpty ? devisEmpty.innerHTML : "";

  async function loadDevisVendeur(){
    if(!devisList) return;
    try {
      const { devis } = await api("/seller/devis");
      const enAttente = devis.filter(d=>d.statut==="EN_ATTENTE").length;
      if(devisBadge){ devisBadge.textContent=enAttente; devisBadge.hidden = enAttente===0; }
      if(devis.length===0){ devisList.innerHTML=""; if(devisEmpty){ devisEmpty.innerHTML=devisEmptyTexte; devisEmpty.hidden=false; } return; }
      if(devisEmpty) devisEmpty.hidden=true;
      devisList.innerHTML = devis.map(devisVendeurCard).join("");
    } catch(e){
      devisList.innerHTML="";
      if(devisEmpty){ devisEmpty.innerHTML = sdvErreurFil(e); devisEmpty.hidden=false; }
    }
  }

  devisList?.addEventListener("click", async (e)=>{
    const btn = e.target.closest("[data-dact]"); if(!btn) return;
    const id = btn.dataset.id, act = btn.dataset.dact;
    btn.setAttribute("disabled","disabled");
    try {
      if(act==="proposer"){
        const v=parseFloat((devisList.querySelector(`[data-devis-montant-input="${id}"]`)?.value||"").replace(",","."));
        if(!(v>0)){ alert(SDV_T("offer.invalidAmount","Indiquez un montant valide.")); btn.removeAttribute("disabled"); return; }
        const msg=(devisList.querySelector(`[data-devis-msg-input="${id}"]`)?.value||"").trim();
        const r=await api(`/seller/devis/${id}/proposer`,"POST",{montantLivraison:v, message:msg||undefined});
        if(r&&r.coordonneesMasquees) alert(SDV_AVERTISSEMENT_COORDONNEES);
      } else if(act==="refuser"){
        await api(`/seller/devis/${id}/refuser`,"POST",{});
      }
      await loadDevisVendeur();
    } catch(err){ alert(err.message||SDV_T("common.error","Erreur")); btn.removeAttribute("disabled"); }
  });

  // ── Messagerie (ventes + achats fusionnés) ──
  const convList = dash.querySelector("[data-sdv-conversations-list]");
  const convEmpty = dash.querySelector("[data-sdv-conversations-empty]");
  const thread = dash.querySelector("[data-sdv-conversation-thread]");
  const msgBadge = dash.querySelector("[data-messages-badge]");
  let activeConv = null;
  let activeRole = "seller";
  const convRoles = {};

  function msgEndpoint(role, id, reply){
    const base = role === "seller" ? "/seller/conversations" : "/customer/conversations";
    if(!id) return base;
    return base + "/" + id + (reply ? "/repondre" : "");
  }

  // Texte d'origine du bloc « aucun message », à restaurer après une panne.
  const convEmptyTexte = convEmpty ? convEmpty.innerHTML : "";

  async function loadConversations(){
    if(!convList) return;
    try {
      const [sellerRes, buyerRes] = await Promise.allSettled([ api("/seller/conversations"), api("/customer/conversations") ]);
      const sellerConvs = (sellerRes.status==="fulfilled" ? (sellerRes.value.conversations||[]) : []).map(c=>({ ...c, _role:"seller" }));
      const buyerConvs  = (buyerRes.status==="fulfilled"  ? (buyerRes.value.conversations||[])  : []).map(c=>({ ...c, _role:"buyer" }));
      const all = sellerConvs.concat(buyerConvs).sort((a,b)=> new Date(b.dernierMessageAt) - new Date(a.dernierMessageAt));
      const unread = sellerConvs.filter(c=>c.nonLuVendeur).length + buyerConvs.filter(c=>c.nonLuAcheteur).length;
      if(msgBadge){ msgBadge.textContent=unread; msgBadge.hidden = unread===0; }
      if(all.length===0){
        convList.innerHTML="";
        // Les deux rôles sont chargés en parallèle : on ne signale une panne que
        // si le rôle vendeur a échoué, celui qui porte ses ventes.
        const echec = sellerRes.status==="rejected" ? sellerRes.reason
          : (buyerRes.status==="rejected" ? buyerRes.reason : null);
        if(convEmpty){ convEmpty.innerHTML = echec ? sdvErreurFil(echec) : convEmptyTexte; convEmpty.hidden=false; }
        return;
      }
      if(convEmpty) convEmpty.hidden=true;
      convList.innerHTML = all.map(c=>{
        convRoles[c.id] = c._role;
        const nonLu = c._role==="seller" ? c.nonLuVendeur : c.nonLuAcheteur;
        const roleLabel = c._role==="seller" ? "Vente" : "Achat";
        const title = c.productTitle || (c._role==="seller" ? (c.acheteurNom||"Acheteur") : "Conversation");
        const sub = c._role==="seller" ? (c.acheteurNom||"Acheteur") : SDV_T("ms_seller","Vendeur");
        const tagStyle = c._role==="seller" ? "background:#e0f2fe;color:#075985" : "background:#fef3c7;color:#92400e";
        return `
        <button class="sdv-msg-card${nonLu?" is-unread":""}${c.id===activeConv?" is-active":""}" data-conv="${c.id}" data-role="${c._role}">
          <span class="sdv-msg-card__top"><span class="sdv-msg-card__name">${esc(title)}</span><span class="sdv-msg-card__date">${dt(c.dernierMessageAt)}</span></span>
          <span class="sdv-msg-card__product"><span class="sdv-msg-role-tag" style="display:inline-block;font-size:10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;padding:1px 6px;border-radius:10px;margin-right:6px;${tagStyle};">${roleLabel}</span>${esc(sub)}</span>
        </button>`;
      }).join("");
    } catch(e){
      convList.innerHTML="";
      if(convEmpty){ convEmpty.innerHTML = sdvErreurFil(e); convEmpty.hidden=false; }
    }
  }

  async function openConversation(id, role){
    activeConv = id; activeRole = role || convRoles[id] || "seller";
    try {
      const { conversation } = await api(msgEndpoint(activeRole, id));
      const selfAuthor = activeRole==="seller" ? "VENDEUR" : "ACHETEUR";
      thread.innerHTML = `
        <div class="sdv-msg-bubbles">${sdvRendreMessages(conversation.messages, selfAuthor, activeRole==="seller"?"seller":"buyer")}</div>
        <div class="sdv-msg-reply"><textarea data-reply placeholder="Votre réponse…"></textarea><button data-reply-send>Envoyer</button></div>`;
      // Une offre se traite depuis le fil comme depuis l'onglet Offres : les
      // deux écrans restent synchronisés puisqu'ils lisent la même offre.
      sdvBrancherOffres(thread, activeRole==="seller"?"seller":"buyer", api, async ()=>{
        await openConversation(id, activeRole); await loadOffres();
      });
      thread.querySelector("[data-reply-send]")?.addEventListener("click", async ()=>{
        const ta = thread.querySelector("[data-reply]"); const msg=(ta?.value||"").trim(); if(!msg) return;
        try { await api(msgEndpoint(activeRole, id, true),"POST",{message:msg}); await openConversation(id, activeRole); await loadConversations(); } catch(err){ alert(err.message); }
      });
      dash.querySelectorAll(".sdv-msg-card").forEach(b=>b.classList.toggle("is-active", b.dataset.conv===id));
      loadConversations();
    } catch(e){
      thread.innerHTML = `<p class="sdv-msg-thread__empty">${sdvErreurFil(e)}</p>`;
    }
  }

  convList?.addEventListener("click",(e)=>{ const b=e.target.closest("[data-conv]"); if(b) openConversation(b.dataset.conv, b.dataset.role); });

  // Chargement initial (les panels existent même cachés)
  loadOffres();
  loadDevisVendeur();
  loadConversations();
})();

// ─────────────────────────────────────────────────────────────
// Espace acheteur : Mes offres + Mes messages
// ─────────────────────────────────────────────────────────────
(function () {
  const root = document.querySelector("[data-sdv-customer-nego]");
  if (!root) return;
  const proxyBase = (root.dataset.proxyBase || "/apps/sdv-marketplace").replace(/\/$/, "");
  function esc(s){return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}
  function eur(c){return (Number(c||0)/100).toLocaleString("fr-FR",{style:"currency",currency:"EUR"});}
  function dt(iso){try{return new Date(iso).toLocaleDateString("fr-FR",{day:"numeric",month:"short"});}catch{return"";}}
  const LBL = { EN_ATTENTE:SDV_T("offerB.st.pending","En attente du vendeur"), ACCEPTEE:SDV_T("offerB.st.toPay","Acceptée — à payer"), REFUSEE:SDV_T("offer.st.refused","Refusée"), CONTRE_PROPOSEE:SDV_T("offerB.st.countered","Contre-proposition reçue"), CONTRE_ACCEPTEE:SDV_T("offerB.st.toPay","Acceptée — à payer"), CONTRE_REFUSEE:SDV_T("offer.st.refused","Refusée"), PAYEE:SDV_T("offer.st.paid","Payée ✓"), EXPIREE:SDV_T("offer.st.expired","Expirée"), ANNULEE:SDV_T("offer.st.cancelled","Annulée") };
  async function api(p,m,b){const r=await fetch(proxyBase+p,{method:m||"GET",credentials:"same-origin",headers:b?{"Content-Type":"application/json"}:undefined,body:b?JSON.stringify(b):undefined});const d=await r.json().catch(()=>({}));if(!r.ok){const e=new Error(d.erreur||SDV_T("common.error","Erreur"));e.statut=r.status;throw e;}return d;}

  // Offres
  const offresEl = root.querySelector("[data-sdv-my-offres]");
  const offresEmpty = root.querySelector("[data-sdv-my-offres-empty]");
  function card(o){
    let act="";
    if(o.statut==="CONTRE_PROPOSEE") act=`<div class="sdv-offre__actions"><button class="sdv-offre__btn sdv-offre__btn--accept" data-act="accepter-contre" data-id="${o.id}">Accepter ${eur(o.contreMontant)}</button><button class="sdv-offre__btn" data-act="refuser-contre" data-id="${o.id}">Refuser</button></div>`;
    else if((o.statut==="ACCEPTEE"||o.statut==="CONTRE_ACCEPTEE")&&o.checkoutUrl) act=`<div class="sdv-offre__actions"><a class="sdv-offre__btn sdv-offre__btn--accept" href="${esc(o.checkoutUrl)}">Payer ${eur(o.contreMontant||o.montant)}</a></div>`;
    else if(o.statut==="EN_ATTENTE") act=`<div class="sdv-offre__actions"><button class="sdv-offre__btn" data-act="annuler" data-id="${o.id}">Annuler mon offre</button></div>`;
    return `<article class="sdv-offre">${o.productImageUrl?`<img class="sdv-offre__img" src="${esc(o.productImageUrl)}" alt="">`:`<div class="sdv-offre__img"></div>`}<div><p class="sdv-offre__title">${esc(o.productTitle)}</p><p class="sdv-offre__prices"><strong>${eur(o.montant)}</strong><span class="sdv-offre__old">${eur(o.prixOriginal)}</span>${o.contreMontant?` · contre : <strong>${eur(o.contreMontant)}</strong>`:""}</p><span class="sdv-offre__status">${LBL[o.statut]||o.statut}</span>${act}</div></article>`;
  }
  const offresEmptyTexte = offresEmpty ? offresEmpty.innerHTML : "";
  async function loadOffres(){
    try{const {offres}=await api("/customer/offres");
      if(!offres.length){offresEl.innerHTML="";if(offresEmpty){offresEmpty.innerHTML=offresEmptyTexte;offresEmpty.hidden=false;}return;}
      if(offresEmpty)offresEmpty.hidden=true; offresEl.innerHTML=offres.map(card).join("");
    }catch(e){
      offresEl.innerHTML="";
      if(offresEmpty){offresEmpty.innerHTML=sdvErreurFil(e);offresEmpty.hidden=false;}
    }
  }
  offresEl?.addEventListener("click", async (e)=>{
    const btn=e.target.closest("[data-act]"); if(!btn) return;
    btn.setAttribute("disabled","disabled");
    try{ await api(`/offres/${btn.dataset.id}/${btn.dataset.act}`,"POST",{}); await loadOffres(); }
    catch(err){ alert(err.message); btn.removeAttribute("disabled"); }
  });

  // Messages
  const convEl = root.querySelector("[data-sdv-my-conversations]");
  const convEmpty = root.querySelector("[data-sdv-my-conversations-empty]");
  const thread = root.querySelector("[data-sdv-my-thread]");
  let active=null;
  const convEmptyTexte = convEmpty ? convEmpty.innerHTML : "";
  async function loadConvs(){
    try{const {conversations}=await api("/customer/conversations");
      if(!conversations.length){convEl.innerHTML="";if(convEmpty){convEmpty.innerHTML=convEmptyTexte;convEmpty.hidden=false;}return;}
      if(convEmpty)convEmpty.hidden=true;
      convEl.innerHTML=conversations.map(c=>`<button class="sdv-msg-card${c.nonLuAcheteur?" is-unread":""}${c.id===active?" is-active":""}" data-conv="${c.id}"><span class="sdv-msg-card__top"><span class="sdv-msg-card__name">${esc(c.productTitle||"Conversation")}</span><span class="sdv-msg-card__date">${dt(c.dernierMessageAt)}</span></span></button>`).join("");
    }catch(e){
      convEl.innerHTML="";
      if(convEmpty){convEmpty.innerHTML=sdvErreurFil(e);convEmpty.hidden=false;}
    }
  }
  async function open(id){
    active=id;
    try{const {conversation}=await api(`/customer/conversations/${id}`);
      thread.innerHTML=`<div class="sdv-msg-bubbles">${sdvRendreMessages(conversation.messages, "ACHETEUR", "buyer")}</div><div class="sdv-msg-reply"><textarea data-reply placeholder="Votre message…"></textarea><button data-send>Envoyer</button></div>`;
      sdvBrancherOffres(thread, "buyer", api, async ()=>{ await open(id); await loadOffres(); });
      thread.querySelector("[data-send]")?.addEventListener("click", async (ev)=>{
        const bouton=ev.currentTarget;const t=thread.querySelector("[data-reply]");const msg=(t?.value||"").trim();
        if(!msg)return;
        bouton.disabled=true;
        try{
          await api(`/customer/conversations/${id}/repondre`,"POST",{message:msg});
          await open(id);await loadConvs();
        }catch(err){alert(err.message);bouton.disabled=false;}
      });
      root.querySelectorAll(".sdv-msg-card").forEach(b=>b.classList.toggle("is-active",b.dataset.conv===id));
      loadConvs();
    }catch(e){
      thread.innerHTML = `<p class="sdv-msg-thread__empty">${sdvErreurFil(e)}</p>`;
    }
  }
  convEl?.addEventListener("click",(e)=>{const b=e.target.closest("[data-conv]");if(b)open(b.dataset.conv);});

  // Devis acheteur
  const devisEl = root.querySelector("[data-sdv-my-devis]");
  const devisEmptyEl = root.querySelector("[data-sdv-my-devis-empty]");
  const DLBL = { EN_ATTENTE:SDV_T("devis.status.pending","En attente du vendeur"), PROPOSE:SDV_T("devis.status.proposed","Devis reçu — à accepter ou refuser"), ACCEPTE:SDV_T("devis.status.accepted","Accepté — à payer"), REFUSE:SDV_T("devis.status.refused","Refusé"), PAYE:SDV_T("devis.status.paid","Payé ✓"), EXPIRE:SDV_T("devis.status.expired","Expiré"), ANNULE:SDV_T("devis.status.cancelled","Annulé") };
  function devisCard(d){
    let act="";
    if(d.statut==="PROPOSE" && d.montantLivraison!=null){
      const total=(d.prixProduit||0)+(d.montantLivraison||0);
      act=`<div class="sdv-offre__actions">
        <button class="sdv-offre__btn sdv-offre__btn--accept" data-dact="accepter" data-id="${d.id}">${SDV_T("devis.accept","Accepter")} · ${SDV_T("devis.shipping","livraison")} ${eur(d.montantLivraison)} · ${SDV_T("common.total","total")} ${eur(total)}</button>
        <button class="sdv-offre__btn" data-dact="refuser" data-id="${d.id}">${SDV_T("common.refuse","Refuser")}</button>
      </div>`;
    } else if(d.statut==="ACCEPTE" && d.checkoutUrl){
      act=`<div class="sdv-offre__actions"><a class="sdv-offre__btn sdv-offre__btn--accept" href="${esc(d.checkoutUrl)}">${SDV_T("common.pay","Payer")} ${eur((d.prixProduit||0)+(d.montantLivraison||0))} →</a></div>`;
    } else if(["EN_ATTENTE","PROPOSE"].includes(d.statut)){
      act=`<div class="sdv-offre__actions"><button class="sdv-offre__btn" data-dact="annuler" data-id="${d.id}">${SDV_T("common.cancel","Annuler")}</button></div>`;
    }
    const dest=[d.destinationCodePostal,d.destinationVille,d.destinationPays].filter(Boolean).join(" ");
    return `<article class="sdv-offre">${d.productImageUrl?`<img class="sdv-offre__img" src="${esc(d.productImageUrl)}" alt="">`:`<div class="sdv-offre__img"></div>`}<div><p class="sdv-offre__title">${esc(d.productTitle)}</p>${dest?`<p style="font-size:12px;color:var(--pierre-500)">${SDV_T("devis.shipTo","Livraison vers")} : ${esc(dest)}</p>`:""}<span class="sdv-offre__status">${DLBL[d.statut]||d.statut}</span>${d.messageVendeur?`<p class="sdv-offre__msg">« ${esc(d.messageVendeur)} »</p>`:""}${act}</div></article>`;
  }
  const devisEmptyTexte = devisEmptyEl ? devisEmptyEl.innerHTML : "";
  async function loadDevisAcheteur(){
    if(!devisEl) return;
    try{const {devis}=await api("/customer/devis");
      if(!devis.length){devisEl.innerHTML="";if(devisEmptyEl){devisEmptyEl.innerHTML=devisEmptyTexte;devisEmptyEl.hidden=false;}return;}
      if(devisEmptyEl)devisEmptyEl.hidden=true; devisEl.innerHTML=devis.map(devisCard).join("");
    }catch(e){
      devisEl.innerHTML="";
      if(devisEmptyEl){devisEmptyEl.innerHTML=sdvErreurFil(e);devisEmptyEl.hidden=false;}
    }
  }
  devisEl?.addEventListener("click", async (e)=>{
    const btn=e.target.closest("[data-dact]"); if(!btn) return;
    btn.setAttribute("disabled","disabled");
    try{ await api(`/devis/${btn.dataset.id}/${btn.dataset.dact}`,"POST",{}); await loadDevisAcheteur(); }
    catch(err){ alert(err.message); btn.removeAttribute("disabled"); }
  });

  loadOffres(); loadConvs(); loadDevisAcheteur();
})();

// ─────────────────────────────────────────────────────────────
// Boost : rangée produits boostés + section "vendeurs à suivre" dynamique
// ─────────────────────────────────────────────────────────────
(function () {
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // Produits boostés
  const boostedSection = document.querySelector("[data-sdv-boosted]");
  if (boostedSection) {
    const base = boostedSection.dataset.proxyBase || "/apps/sdv-marketplace";
    const grid = boostedSection.querySelector("[data-sdv-boosted-grid]");
    fetch(base + "/boosted-products", { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((data) => {
        const products = (data && data.products) || [];
        if (!products.length || !grid) return;
        grid.innerHTML = products.map((p) => {
          const url = p.handle ? "/products/" + encodeURIComponent(p.handle) : "#";
          const price = p.price != null ? Number(p.price).toLocaleString("fr-FR") + " €" : "";
          const img = p.imageUrl
            ? `<img src="${esc(p.imageUrl)}" alt="${esc(p.title)}" loading="lazy">`
            : `<div class="product-card__placeholder"></div>`;
          return `<a class="product-card" href="${url}">
            <div class="product-card__media"><span class="product-card__boost">★ En avant</span>${img}</div>
            <div class="product-card__info">
              ${p.vendor ? `<span class="product-card__brand">${esc(p.vendor)}</span>` : ""}
              <span class="product-card__title">${esc(p.title)}</span>
              <div class="product-card__prices"><span class="product-card__price-now">${esc(price)}</span></div>
            </div>
          </a>`;
        }).join("");
        boostedSection.hidden = false;
      })
      .catch(() => {});
  }

  // L'intention est mémorisée avant de partir vers la connexion : si Shopify
  // perd le chemin de retour, le vendeur qui revient sur son espace atterrit
  // quand même sur l'encart de mise en avant.
  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-sdv-vendors-cta]")) return;
    try { sessionStorage.setItem("sdv_intention", "mise-en-avant"); } catch (e) {}
  });

  // Vendeurs à suivre (boostés) — remplace les blocs manuels si le backend renvoie des vendeurs
  const vendorsSection = document.querySelector("[data-sdv-vendors]");
  if (vendorsSection) {
    const base = vendorsSection.dataset.proxyBase || "/apps/sdv-marketplace";
    const grid = vendorsSection.querySelector("[data-sdv-vendors-grid]");
    const boostLabel = (window.SDV_T ? window.SDV_T("boost.sellerBadge", "Boutique en avant") : "Boutique en avant");
    fetch(base + "/boosted-sellers", { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : { sellers: [] }))
      .then((data) => {
        const sellers = (data && data.sellers) || [];
        if (!sellers.length || !grid) return; // garde le fallback manuel
        grid.innerHTML = sellers.map((v) => {
          const avatar = v.avatarUrl
            ? `<img src="${esc(v.avatarUrl)}" alt="${esc(v.name)}" loading="lazy" width="200" height="200">`
            : `<div class="collection-vendors__avatar--ph" aria-hidden="true">${esc((v.name || "?").slice(0, 1).toUpperCase())}</div>`;
          // Tant qu'une boutique n'a pas d'avis, le nombre d'annonces en ligne
          // est le seul repère concret qu'on puisse donner à l'acheteur.
          const nbAnnonces = v.productsCount
            ? v.productsCount + (v.productsCount > 1 ? " annonces" : " annonce")
            : null;
          const stats = [v.rating ? "★ " + v.rating : null, v.reviewsCount ? v.reviewsCount + " avis" : null, nbAnnonces].filter(Boolean).join(" · ");
          // Le badge n'apparaît que sur les boutiques ayant réellement souscrit.
          // Avant l'ouverture de l'option, la section montre les boutiques les
          // mieux fournies — les afficher badgées serait mensonger et viderait
          // l'option de son intérêt.
          const badge = v.boosted
            ? `<span class="collection-vendors__boost">★ ${esc(boostLabel)}</span>`
            : "";
          // Le texte est regroupé dans un bloc : sur mobile la carte devient
          // « avatar | contenu » sans avoir à compter les lignes de la grille,
          // ce qui casserait dès qu'une boutique n'a pas de présentation.
          return `<a class="collection-vendors__card" href="${esc(v.url || "#")}">
            <div class="collection-vendors__avatar">${avatar}</div>
            <div class="collection-vendors__body">
              ${badge}
              <h3>${esc(v.name)}</h3>
              ${v.role ? `<p class="collection-vendors__role">${esc(v.role)}</p>` : ""}
              ${v.description ? `<p class="collection-vendors__desc">${esc(v.description)}</p>` : ""}
              ${stats ? `<p class="collection-vendors__meta">${esc(stats)}</p>` : ""}
            </div>
          </a>`;
        }).join("");
        // Peu de boutiques mises en avant : la grille 4 colonnes laisserait une
        // carte seule collée à gauche → on centre sur le nombre réel de cartes.
        // Au-delà de 4, on passe en défilement horizontal.
        grid.setAttribute("data-count", String(Math.min(sellers.length, 4)));
        vendorsSection.classList.toggle("collection-vendors--carousel", sellers.length > 4);
      })
      .catch(() => {});
  }

  // Badge « Boutique en avant » sur la page publique du vendeur : on interroge
  // la même route publique et on révèle le badge si ce vendeur y figure.
  const vendorBoostBadge = document.querySelector("[data-sdv-vendor-boost-badge]");
  if (vendorBoostBadge) {
    const handle = vendorBoostBadge.dataset.sellerHandle || "";
    const base = vendorBoostBadge.dataset.proxyBase || "/apps/sdv-marketplace";
    if (handle) {
      fetch(base + "/boosted-sellers", { credentials: "same-origin" })
        .then((r) => (r.ok ? r.json() : { sellers: [] }))
        .then((data) => {
          // La liste contient aussi les boutiques mises en avant d'office pour
          // le lancement : figurer dedans ne suffit pas, seul un boost payé
          // donne droit au badge.
          const boosted = ((data && data.sellers) || []).some((v) => v.handle === handle && v.boosted === true);
          if (boosted) vendorBoostBadge.hidden = false;
        })
        .catch(() => {});
    }
  }
})();

// ─────────────────────────────────────────────────────────────
// Shelf "Nouveautés" : flèches de défilement du carrousel
// ─────────────────────────────────────────────────────────────
(function () {
  document.querySelectorAll("[data-shelf-carousel]").forEach((carousel) => {
    const scroller = carousel.querySelector("[data-shelf-scroller]");
    const prev = carousel.querySelector("[data-shelf-prev]");
    const next = carousel.querySelector("[data-shelf-next]");
    if (!scroller || !prev || !next) return;

    function step() {
      const card = scroller.querySelector(".product-card");
      const w = card ? card.getBoundingClientRect().width : 280;
      // défile d'environ 2 cartes (ou la largeur visible si plus petit)
      return Math.min(scroller.clientWidth, w * 2);
    }
    function update() {
      const max = scroller.scrollWidth - scroller.clientWidth - 4;
      const noOverflow = scroller.scrollWidth <= scroller.clientWidth + 4;
      prev.classList.toggle("is-hidden", noOverflow || scroller.scrollLeft <= 4);
      next.classList.toggle("is-hidden", noOverflow || scroller.scrollLeft >= max);
    }
    prev.addEventListener("click", () => { scroller.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", () => { scroller.scrollBy({ left: step(), behavior: "smooth" }); });
    scroller.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
})();
